export const lines = [
    {
        "id": 1,
        "name": "湿地旅鸟与山林夏候鸟初探",
        "center": [
            29.780396,
            118.451787
        ],
        "zoom": 9,
        "points": [
            {
                "s_id": "1_1",
                "name": "屯溪区（主要观鸟点）",
                "address": "黄山市屯溪区黎阳镇傍霞村",
                "desc": "傍霞村森林湿地树荫茂密，有鸟类 30 余种，重点观赏具有福寿寓意的寿带鸟。可沿着铺设好的步行道沉浸式观鸟赏景，可使用观鸟屋、远程监控等设施，还能在观鸟景观台及观赏点全方位观察鸟类。",
                "thumbs": [
                    "line/marker/1_1/屯溪区点位代表照片.png"
                ],
                "longitude": 118.258492,
                "latitude": 29.675683,
                "icon": "line/1/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.313612,
                "icon_latitude": 29.694147
            },
            {
                "s_id": "1_2",
                "name": "徽州区（主要观鸟点）",
                "address": "黄山市徽州区西溪南镇  西溪南村",
                "desc": "可观赏包括白鹭、夜鹭、寿带、普通鳾等在内的更多鸟类栖息。观鸟爱好者可在湿地观鸟台使用专业设备，近距离观察这些珍稀鸟类的自然行为。还可以赏“绿野仙踪”千亩枫杨林湿地，体验西西里秘境、丰溪竹筏、小火车等新业态。",
                "thumbs": [
                    "line/marker/1_2/徽州区代表图片.jpg"
                ],
                "longitude": 118.286,
                "latitude": 29.837556,
                "icon": "line/1/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.335339,
                "icon_latitude": 29.879397
            },
            {
                "s_id": "1_3",
                "name": "黄山风景区",
                "address": "黄山区汤口镇 205 国道",
                "desc": "可观赏猴谷鸮类 、光明顶雀类；天都峰棕噪鹛、光明顶雀类；迎客松、梦笔生花、红嘴相思鸟，打卡西海小火车，南门下、梦笔生花、红嘴相思鸟，打卡西海小火车",
                "thumbs": [
                    "line/marker/1_3/黄山区-黄山风景区.jpg",
                    "line/marker/1_3/黄山区-黄山风景区1.jpg",
                    "line/marker/1_3/黄山区-黄山风景区2.jpg"
                ],
                "longitude": 118.170467,
                "latitude": 30.126561,
                "id": 71,
                "icon": "line/1/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.136973,
                "icon_latitude": 30.161728
            }
        ]
    },
    {
        "id": 2,
        "name": "山林繁殖鸟与水域夏候鸟奇观",
        "center": [
            29.900396,
            118.451787
        ],
        "zoom": 9.3,
        "points": [
            {
                "s_id": "2_1",
                "name": "屯溪区（主要观鸟点）",
                "address": "黄山市屯溪区黎阳镇傍霞村",
                "desc": "傍霞村森林湿地树荫茂密，有鸟类 30 余种，重点观赏具有福寿寓意的寿带鸟。可沿着铺设好的步行道沉浸式观鸟赏景，可使用观鸟屋、远程监控等设施，还能在观鸟景观台及观赏点全方位观察鸟类。",
                "thumbs": [
                    "line/marker/2_1/屯溪区点位代表照片.png"
                ],
                "longitude": 118.258492,
                "latitude": 29.675683,
                "icon": "line/2/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.313612,
                "icon_latitude": 29.694147
            },
            {
                "s_id": "2_2",
                "name": "休宁县（主要观鸟点）",
                "address": "休宁县横江公园",
                "desc": "鸟类资源丰富，共有7目13科35种，其中国家一级保护动物有东方白鹳、白鹤，国家二级保护动物有灰鹤、海南鳽、黄嘴白鹭、鸳鸯和小天鹅",
                "thumbs": [
                    "line/marker/2_2/1.jpg"
                ],
                "longitude": 118.186683,
                "latitude": 29.769337,
                "icon": "line/2/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.165652,
                "icon_latitude": 29.792399
            },
            {
                "s_id": "2_3",
                "name": "黄山风景区",
                "address": "黄山区汤口镇 205 国道",
                "desc": "可观赏猴谷鸮类 、光明顶雀类；天都峰棕噪鹛、光明顶雀类；迎客松、梦笔生花、红嘴相思鸟，打卡西海小火车，南门下、梦笔生花、红嘴相思鸟，打卡西海小火车",
                "thumbs": [
                    "line/marker/2_3/黄山区-黄山风景区.jpg",
                    "line/marker/2_3/黄山区-黄山风景区1.jpg",
                    "line/marker/2_3/黄山区-黄山风景区2.jpg"
                ],
                "longitude": 118.170467,
                "latitude": 30.126561,
                "id": 71,
                "icon": "line/2/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.136973,
                "icon_latitude": 30.161728
            }
        ]
    },
    {
        "id": 3,
        "name": "湿地迁徙潮与山林留鸟多样性",
        "center": [
            30.0396,
            118.451787
        ],
        "zoom": 9.5,
        "points": [
            {
                "s_id": "3_1",
                "name": "歙县（主要观鸟点）",
                "address": "歙县王村镇",
                "desc": "鸟类资源丰富，有雁鸭等鸟类，摄影爱好者曾多次在此拍摄到他们的身影。在这里，游客能静看各种鸟类翱翔，尽享惬意时光。",
                "thumbs": [
                    "line/marker/3_1/歙县代表图片.jpg"
                ],
                "longitude": 118.399645,
                "latitude": 29.757617,
                "icon": "line/3/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.456523,
                "icon_latitude": 29.850634
            },
            {
                "s_id": "3_2",
                "name": "黄山区（主要观鸟点）",
                "address": "浦溪河休闲旅游区",
                "desc": "浦溪河休闲旅游区，总长1.6km，同时结合了景观、游憩、观鸟、休闲等活动，将此区域打造成自然生态的湿地公园。同时设有14米高的观鸟塔,可登高俯瞰整个湿地景色，又可远观黄山景色。",
                "thumbs": [
                    "line/marker/3_2/黄山区代表图.jpg"
                ],
                "longitude": 118.146142,
                "latitude": 30.258982,
                "icon": "line/3/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.126371,
                "icon_latitude": 30.227949
            },
            {
                "s_id": "3_3",
                "name": "黟县（主要观鸟点）",
                "address": "黟县奇墅湖",
                "desc": "观赏小䴙䴘、翠鸟，观看《宏村·阿菊》演艺",
                "thumbs": [
                    "line/marker/3_3/黟县代表图.jpg"
                ],
                "longitude": 118.00161,
                "latitude": 29.987383,
                "icon": "line/3/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.893428,
                "icon_latitude": 29.929844
            }
        ]
    },
    {
        "id": 4,
        "name": "濒危物种与冬候鸟集群盛宴",
        "center": [
            29.180396,
            118.251787
        ],
        "zoom": 9.2,
        "points": [
            {
                "s_id": "4_1",
                "name": "徽州区（主要观鸟点）",
                "address": "黄山市徽州区西溪南镇  西溪南村",
                "desc": "可观赏包括白鹭、夜鹭、寿带、普通鳾等在内的更多鸟类栖息。观鸟爱好者可在湿地观鸟台使用专业设备，近距离观察这些珍稀鸟类的自然行为。还可以赏“绿野仙踪”千亩枫杨林湿地，体验西西里秘境、丰溪竹筏、小火车等新业态。",
                "thumbs": [
                    "line/marker/4_1/徽州区代表图片.jpg"
                ],
                "longitude": 118.286,
                "latitude": 29.837556,
                "icon": "line/4/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.266456,
                "icon_latitude": 29.923866
            },
            {
                "s_id": "4_2",
                "name": "歙县（主要观鸟点）",
                "address": "歙县王村镇",
                "desc": "鸟类资源丰富，有雁鸭等鸟类，摄影爱好者曾多次在此拍摄到他们的身影。在这里，游客能静看各种鸟类翱翔，尽享惬意时光。",
                "thumbs": [
                    "line/marker/4_2/歙县代表图片.jpg"
                ],
                "longitude": 118.399645,
                "latitude": 29.757617,
                "icon": "line/4/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.456523,
                "icon_latitude": 29.850634
            },
            {
                "s_id": "4_3",
                "name": "屯溪区（主要观鸟点）",
                "address": "黄山市屯溪区黎阳镇傍霞村",
                "desc": "傍霞村森林湿地树荫茂密，有鸟类 30 余种，重点观赏具有福寿寓意的寿带鸟。可沿着铺设好的步行道沉浸式观鸟赏景，可使用观鸟屋、远程监控等设施，还能在观鸟景观台及观赏点全方位观察鸟类。",
                "thumbs": [
                    "line/marker/4_3/屯溪区点位代表照片.png"
                ],
                "longitude": 118.258492,
                "latitude": 29.675683,
                "icon": "line/4/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.313612,
                "icon_latitude": 29.694147
            },
            {
                "s_id": "4_4",
                "name": "祁门（主要观鸟点）",
                "address": "祁门县石迹村",
                "desc": "该点位可观测到40余种鸟类，其中包括白鹇、白颈长尾雉、红嘴蓝鹊等，以白鹇为主，总体数量有百余只。\n白鹇为晨昏活动，因此可选择全年的早上7-9时以及下午4-6时进行观鸟和拍摄。",
                "thumbs": [
                    "line/marker/4_4/祁门县代表图.jpg"
                ],
                "longitude": 117.532098,
                "latitude": 29.866307,
                "icon": "line/4/4.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.707584,
                "icon_latitude": 29.829756
            }
        ]
    },
    {
        "id": 5,
        "name": "黄山生态全景·全域综合观鸟",
        "center": [
            30.280396,
            118.451787
        ],
        "zoom": 9.2,
        "points": [
            {
                "s_id": "5_1",
                "name": "黄山区（主要观鸟点）",
                "address": "浦溪河休闲旅游区",
                "desc": "浦溪河休闲旅游区，总长1.6km，同时结合了景观、游憩、观鸟、休闲等活动，将此区域打造成自然生态的湿地公园。同时设有14米高的观鸟塔,可登高俯瞰整个湿地景色，又可远观黄山景色。",
                "thumbs": [
                    "line/marker/5_1/黄山区代表图.jpg"
                ],
                "longitude": 118.146142,
                "latitude": 30.258982,
                "icon": "line/5/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.126371,
                "icon_latitude": 30.257949
            },
            {
                "s_id": "5_2",
                "name": "休宁县（主要观鸟点）",
                "address": "休宁县横江公园",
                "desc": "鸟类资源丰富，共有7目13科35种，其中国家一级保护动物有东方白鹳、白鹤，国家二级保护动物有灰鹤、海南鳽、黄嘴白鹭、鸳鸯和小天鹅",
                "thumbs": [
                    "line/marker/5_2/1.jpg"
                ],
                "longitude": 118.186683,
                "latitude": 29.769337,
                "icon": "line/5/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.165652,
                "icon_latitude": 29.792399
            },
            {
                "s_id": "5_3",
                "name": "歙县（主要观鸟点）",
                "address": "歙县王村镇",
                "desc": "鸟类资源丰富，有雁鸭等鸟类，摄影爱好者曾多次在此拍摄到他们的身影。在这里，游客能静看各种鸟类翱翔，尽享惬意时光。",
                "thumbs": [
                    "line/marker/5_3/歙县代表图片.jpg"
                ],
                "longitude": 118.399645,
                "latitude": 29.757617,
                "icon": "line/5/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.456523,
                "icon_latitude": 29.850634
            }
        ]
    },
    {
        "id": 6,
        "name": "鹇栖秘境·水口园林摄影线",
        "center": [
            29.84396,
            118.451787
        ],
        "zoom": 11,
        "points": [
            {
                "s_id": "6_1",
                "name": "西溪南",
                "address": "徽州区松明山公路",
                "desc": "可观赏普通鳾，秘境小火车，雾拍白鹇，寿带鸟，鸳鸯、罗汉松，赏“绿野仙踪”千亩枫杨林湿地、西西里秘境、丰溪竹筏、小火车等新业态",
                "thumbs": [
                    "line/marker/6_1/徽州区-西溪南.jpg",
                    "line/marker/6_1/徽州区-西溪南1.jpg",
                    "line/marker/6_1/徽州区-西溪南2.jpg"
                ],
                "longitude": 118.28485,
                "latitude": 29.84041,
                "id": 83,
                "icon": "line/6/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.382203,
                "icon_latitude": 29.811493
            },
            {
                "s_id": "6_2",
                "name": "唐模",
                "address": "黄山市徽州区潜口镇唐模村潜唐路1号",
                "desc": "可观赏古银杏、水口园林，观赏槐荫树，研学基地，唐朝模范村，赏古银杏",
                "thumbs": [
                    "line/marker/6_2/唐模晒秋 (2).jpg",
                    "line/marker/6_2/唐模晒秋 (3).jpg",
                    "line/marker/6_2/唐模晒秋 (4).jpg",
                    "line/marker/6_2/唐模晒秋.jpg"
                ],
                "longitude": 118.336109,
                "latitude": 29.868462,
                "id": 132,
                "icon": "line/6/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.322012,
                "icon_latitude": 29.8113
            },
            {
                "s_id": "6_3",
                "name": "呈坎",
                "address": "黄山市徽州区呈坎镇宝纶路78号",
                "desc": "可观赏徽派建筑与古桂树、永兴湖、宝纶阁",
                "thumbs": [
                    "line/marker/6_3/1.jpg",
                    "line/marker/6_3/2.jpg",
                    "line/marker/6_3/3.jpg",
                    "line/marker/6_3/4.jpg"
                ],
                "longitude": 118.280803,
                "latitude": 29.914335,
                "id": 131,
                "icon": "line/6/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.300303,
                "icon_latitude": 29.870303
            },
            {
                "s_id": "6_4",
                "name": "大灵山旅游度假区",
                "address": "徽州区零四三村道",
                "desc": "可观赏爱情主题村落，观赏榆树",
                "thumbs": [
                    "line/marker/6_4/徽州区-大灵山度假区.jpg",
                    "line/marker/6_4/徽州区-大灵山度假区1.jpg",
                    "line/marker/6_4/徽州区-大灵山度假区2.jpg",
                    "line/marker/6_4/徽州区-大灵山度假区3.jpg"
                ],
                "longitude": 118.320372,
                "latitude": 29.916144,
                "id": 79,
                "icon": "line/6/4.png",
                "icon_scale": 90,
                "wh": 1.417,
                "icon_longitude": 118.370303,
                "icon_latitude": 29.870303,
                "recommend": [
                    {
                        "name": "浪漫花涧民宿",
                        "tel": "18255922929",
                        "address": "徽州区043乡道下横街66号"
                    }
                ]
            },
            {
                "s_id": "6_5",
                "name": "新安江山水画廊",
                "address": "黄山市歙县深渡镇新安江山水画廊景区",
                "desc": "可观赏九姓捕鱼表演、千年古樟树，九龙潭冰雪世界、绵潭戏院",
                "thumbs": [
                    "line/marker/6_5/DJI_1.jpg",
                    "line/marker/6_5/汪平徽-秋染新安江.jpg"
                ],
                "longitude": 118.618285,
                "latitude": 29.862743,
                "id": 143,
                "icon": "line/6/5.png",
                "icon_scale": 90,
                "wh": 1.231,
                "icon_longitude": 118.456523,
                "icon_latitude": 29.850634
            },
            {
                "s_id": "6_6",
                "name": "昌溪村",
                "address": "歙县昌溪乡昌溪村",
                "desc": "昌溪村，原名沧溪，是一座依山傍水的古朴村落，被誉为“歙南第一村”，打出名震一时的“吴氏茶叶”牌、“周氏漆器”牌，也构筑了由南到北长达3公里的古建筑群体。",
                "thumbs": [
                    "line/marker/6_6/昌溪村1.jpg",
                    "line/marker/6_6/昌溪村2.jpg",
                    "line/marker/6_6/昌溪村3.jpg",
                    "line/marker/6_6/昌溪村4.jpg"
                ],
                "longitude": 118.641797,
                "latitude": 29.89509,
                "icon": "line/6/6.png",
                "icon_scale": 90,
                "wh": 2.28,
                "icon_longitude": 118.526523,
                "icon_latitude": 29.890634,
                "recommend": [
                    {
                        "name": "千百渡生态农庄",
                        "tel": "0559-2751616 ",
                        "address": "歙县深渡镇大茂村1号"
                    },
                    {
                        "name": "披云山庄（歙县）",
                        "tel": "0559-6530000",
                        "address": "歙县徽城镇披云路7号"
                    },
                    {
                        "name": "渔梁往事",
                        "tel": "0559-2610800",
                        "address": "歙县徽城镇渔梁街渔梁景区"
                    },
                    {
                        "name": "芳华酒店",
                        "tel": "15755985488",
                        "address": "歙县徽城镇西街一号"
                    }
                ]
            }
        ]
    },
    {
        "id": 7,
        "name": "鹭舞浦溪·湿地古树摄影线",
        "center": [
            30.2396,
            118.051787
        ],
        "zoom": 9.8,
        "points": [
            {
                "s_id": "7_1",
                "name": "秀里村",
                "address": "黄山市黟县宏村镇龙江村",
                "desc": "可体验旅拍，观赏域见未来草坪露营、云起艺术馆",
                "thumbs": [
                    "line/marker/7_1/HYPERLAPSE_0003-已增强-NR 拷贝.jpg",
                    "line/marker/7_1/图片15.jpg"
                ],
                "longitude": 117.952762,
                "latitude": 29.955424,
                "id": 141,
                "icon": "line/7/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.841755,
                "icon_latitude": 29.929516
            },
            {
                "s_id": "7_2",
                "name": "奇墅湖",
                "address": "黟县宏村镇奇墅村",
                "desc": "奇墅湖，又名“东方红水库”，是位于中国安徽省黟县宏村镇宏村西南方向3公里处的湖泊，距离县城10公里。该湖深水区域水深可达几十米，湖光山色交相辉映，景色宜人。",
                "thumbs": [
                    "line/marker/7_2/奇墅湖.jpg"
                ],
                "longitude": 117.98313,
                "latitude": 29.977482,
                "icon": "line/7/2.png",
                "icon_scale": 90,
                "wh": 1.679,
                "icon_longitude": 117.982178,
                "icon_latitude": 30.02322,
                "recommend": [
                    {
                        "name": "黟县奇墅仙境国际大酒店",
                        "tel": "0559-5548801",
                        "address": "黟县宏村镇奇墅村"
                    }
                ]
            },
            {
                "s_id": "7_3",
                "name": "芙蓉谷景区",
                "address": "黄山区耿诚镇辅村",
                "desc": "可观赏天空之境、体验山地飞车体验",
                "thumbs": [
                    "line/marker/7_3/黄山区-芙蓉谷.jpg",
                    "line/marker/7_3/黄山区-芙蓉谷1.jpg"
                ],
                "longitude": 118.158817,
                "latitude": 30.193576,
                "id": 74,
                "icon": "line/7/3.png",
                "icon_scale": 90,
                "wh": 1.875,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.329371,
                "icon_latitude": 30.077949,
                "recommend": [
                    {
                        "name": "黄山荣逸度假酒店",
                        "tel": "0559-8598888 ",
                        "address": "黄山区耿城镇辅村村浦溪水镇境内1号"
                    },
                    {
                        "name": "谭家大院",
                        "tel": "15805596622",
                        "address": "黄山区耿城镇饶村，梨园路与新三路交叉口东北方向100米"
                    }
                ]
            },
            {
                "s_id": "7_4",
                "name": "沟村",
                "address": "耿城镇沟村村委会",
                "desc": "沟村“长寿村”紧邻太平索道古村风貌与长寿文化为特色，有百岁坊、老街、古民居及非遗馆、陶艺馆等文化体验点，可漫步生态步道、参与户外互动，配套民宿与农家菜，周边联动黄山北门、芙蓉谷，是融合山水、人文与乡村体验的好去处。",
                "thumbs": [
                    "line/marker/7_4/10沟村.jpg"
                ],
                "longitude": 118.164714,
                "latitude": 30.227855,
                "icon": "line/7/4.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.129371,
                "icon_latitude": 30.127949
            },
            {
                "s_id": "7_5",
                "name": "浦溪河休闲旅游区",
                "address": "浦溪河休闲旅游区",
                "desc": "地处城区近郊，交通便捷，湿地步道24小时免费开放。到浦溪河在晨雾或夕阳拍白鹭、夜鹭、野鸭等，赏120余亩湿地、观鸟塔、梦幻黄山文化体验馆等。",
                "thumbs": [
                    "line/marker/7_5/1.jpg",
                    "line/marker/7_5/2.jpg",
                    "line/marker/7_5/3.jpg"
                ],
                "longitude": 118.146142,
                "latitude": 30.258982,
                "icon": "line/7/5.png",
                "icon_scale": 90,
                "wh": 1.408,
                "icon_longitude": 118.126371,
                "icon_latitude": 30.257949
            },
            {
                "s_id": "7_6",
                "name": "梦幻黄山文化体验馆",
                "address": "黄山市黄山区甘棠镇",
                "desc": "可观赏裸眼5D电影《飞越黄山》",
                "thumbs": [
                    "line/marker/7_6/IMG_4693(20240502-094158).JPG",
                    "line/marker/7_6/IMG_4694(20240502-102922).JPG",
                    "line/marker/7_6/IMG_4695.PNG",
                    "line/marker/7_6/IMG_4696(20240502-103108).JPG"
                ],
                "longitude": 118.132574,
                "latitude": 30.279578,
                "id": 41,
                "icon": "line/7/6.png",
                "icon_scale": 90,
                "wh": 1.501,
                "icon_longitude": 117.986371,
                "icon_latitude": 30.297949
            },
            {
                "s_id": "7_7",
                "name": "黄山区新明乡樵山古榧树群",
                "address": "新明乡樵山村",
                "desc": "位于新明乡樵山村，拥有百年古榧树两百余株，其中千年古榧2株，500年以上古榧6株，由5处集中连片的区域构成，占地面积约110余亩。最大一株胸围达7.1米，相传古树被神仙拂过，被当地百姓称为“神仙榧、香榧王”。这里也是《黄山报》旧址所在地，1947年秋，中共皖南地委在这里创刊发行了苏浙皖根据地唯一一份党报——《黄山报》，革命的曙光曾在这里升起，您可以在《黄山报》旧址浏览图文并茂的展板，观赏珍稀的历史文物。",
                "thumbs": [
                    "marker/13/13-黄山区新明乡樵山古榧树群.jpg"
                ],
                "longitude": "118.227268",
                "latitude": "30.394392",
                "icon": "line/7/7.png",
                "icon_scale": 90,
                "wh": 1.224,
                "icon_longitude": 118.306371,
                "icon_latitude": 30.297949
            }
        ]
    },
    {
        "id": 8,
        "name": "鸟羽纷飞·绿叶珍禽摄影线",
        "center": [
            29.70396,
            118.251787
        ],
        "zoom": 10.2,
        "points": [
            {
                "s_id": "8_1",
                "name": "傍霞村观鸟基地",
                "address": "屯溪区黎阳镇鬲山大道19号",
                "desc": "这里树荫茂密，有鸟类 30 余种，重点观赏具有福寿寓意的寿带鸟。村里专门设置了保护屏障与告示牌，保护了400余亩茶园、林地，为鸟类提供了优良栖息空间。沿着铺设好的步行道沉浸式观鸟赏景，可使用观鸟屋、远程监控等设施，还能在观鸟景观台及观赏点全方位观察鸟类。",
                "thumbs": [
                    "line/marker/8_1/12傍霞村观鸟基地.png"
                ],
                "longitude": 118.258492,
                "latitude": 29.675683,
                "icon": "line/8/1.png",
                "icon_scale": 90,
                "wh": 1.212,
                "icon_longitude": 118.396288,
                "icon_latitude": 29.695328
            },
            {
                "s_id": "8_2",
                "name": "鬲山风景区",
                "address": "屯溪区黎阳镇鬲山",
                "desc": "鬲山风景区位于安徽省黄山市屯溪区西南郊的黎阳镇新江村，地处率水河南岸，是屯溪古八景之一，以佛教文化底蕴、自然生态及石窟奇观为特色",
                "thumbs": [
                    "line/marker/8_2/13鬲山风景区.png"
                ],
                "longitude": 118.262977,
                "latitude": 29.664457,
                "icon": "line/8/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.321381,
                "icon_latitude": 29.634286
            },
            {
                "s_id": "8_3",
                "name": "懒鸟营地",
                "address": "屯溪区黎阳镇傍霞村衍上老电灌站",
                "desc": "懒鸟营地坐落于屯溪区黎阳镇傍霞村，这里有配备完善设施的帐篷餐饮，还有咖啡屋、书屋、水上皮划艇等休闲娱乐设施。同时，它也是傍霞村打造观鸟产业村落的新支点，在这里，游客能静看白鹭掠过田间，尽享惬意时光 。",
                "thumbs": [
                    "line/marker/8_3/懒鸟营地7.jpg",
                    "line/marker/8_3/懒鸟营地.jpg",
                    "line/marker/8_3/懒鸟营地9.jpg"
                ],
                "longitude": 118.253212,
                "latitude": 29.669567,
                "icon": "line/8/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.242416,
                "icon_latitude": 29.680209
            },
            {
                "s_id": "8_4",
                "name": "兰水河月亮湾",
                "address": "屯溪区黎阳镇傍霞村衍上老电灌站",
                "desc": "屯溪区兰水河月亮湾，位于黎阳镇傍霞村，是一个因水环境生态修复工程而焕然一新的网红景点。村庄还结合和美乡村建设，增添了水上游乐设施、骑行步道等。无论是漫步林间小道，还是参加水上趣味活动，都能让人感受到大自然的美好与乡村的独特魅力",
                "thumbs": [
                    "line/marker/8_4/15兰水河月亮湾.JPG"
                ],
                "longitude": 118.250263,
                "latitude": 29.669878,
                "icon": "line/8/4.png",
                "icon_scale": 90,
                "wh": 2.53,
                "icon_longitude": 118.293612,
                "icon_latitude": 29.754147,
                "recommend": [
                    {
                        "name": "懒鸟营地",
                        "tel": "18155973331",
                        "address": "屯溪区黎阳镇傍霞村衍上老电灌站"
                    },
                    {
                        "name": "中国徽菜博物馆",
                        "tel": "0559-2333777",
                        "address": "屯溪区迎宾大道62号"
                    },
                    {
                        "name": "霞隐民宿集群",
                        "tel": "19155921616",
                        "address": "屯溪区黎阳镇傍霞村树仑10号"
                    }
                ]
            },
            {
                "s_id": "8_5",
                "name": "五城镇低台村苦槠树",
                "address": "休宁县五城镇低台村苦株树故事民宿",
                "desc": "静默伫立着一棵阅尽千六百载沧桑的苦槠古树。其躯干虬枝盘曲，中阔竟可容十人环抱，如大地张开的怀抱，寓意深长：迎客松以秀姿相迎八方来客，苦槠树则以宏阔之量诚纳四海宾朋。当您信步于民宿小径，不经意间便会与这株千年“树灵”相遇。置身于古木苍劲的虬枝与雅致民宿交织的独特空间，浓荫如盖，树影斑驳，您将真切触摸到岁月馈赠的厚重，沉醉于自然伟力与人文匠心完美交融的隽永意境之中。",
                "thumbs": [
                    "line/marker/8_5/用树的图.jpg",
                    "line/marker/8_5/用树的图1.jpg",
                    "line/marker/8_5/苦株民宿.png"
                ],
                "longitude": 118.089035,
                "latitude": 29.563553,
                "icon": "line/8/8.png",
                "icon_scale": 117,
                "wh": 1.086,
                "icon_longitude": 118.165652,
                "icon_latitude": 29.792399
            },
            {
                "s_id": "8_6",
                "name": "横江湿地公园",
                "address": "休宁县樟树岛",
                "desc": "横江湿地公园，西起东亭河与横江交汇口，东达南潜大桥，北至东关碣，属河流型湿地公园，有樟树岛、鳌广场等水上活动区、体育健身区、文化体验区，该点位鸟类资源丰富，共有7目13科35种，其中国家一级保护动物有东方白鹳、白鹤，国家二级保护动物有灰鹤、海南鳽、黄嘴白鹭、鸳鸯和小天鹅。",
                "thumbs": [
                    "line/marker/8_6/3 横江公园 (3).jpg",
                    "line/marker/8_6/3 横江公园 (4).jpg",
                    "line/marker/8_6/3 横江公园 (5).JPG"
                ],
                "longitude": 118.265152,
                "latitude": 29.741381,
                "icon": "line/8/5.png",
                "icon_scale": 90,
                "wh": 1.358,
                "icon_longitude": 118.05198,
                "icon_latitude": 29.808988
            },
            {
                "s_id": "8_7",
                "name": "向云端·世界观光列车微公园",
                "address": "黄山市休宁县齐云山镇张村",
                "desc": "可打卡“道境鸟视界”、网红小火车",
                "thumbs": [
                    "line/marker/8_7/1.png",
                    "line/marker/8_7/2.png",
                    "line/marker/8_7/微信图片_20240418150732.jpg"
                ],
                "longitude": 118.084877,
                "latitude": 29.811371,
                "id": 139,
                "icon": "line/8/6.png",
                "icon_scale": 90,
                "wh": 2.016,
                "icon_longitude": 118.021581,
                "icon_latitude": 29.66227
            },
            {
                "s_id": "8_8",
                "name": "祖源村来龙山",
                "address": "休宁县溪口镇祖源村",
                "desc": "有着安徽之最——千年红豆杉，高25米，胸围5米，冠幅20米，被视为“神树”",
                "thumbs": [
                    "line/marker/8_8/18 祖源村来龙山.jpg"
                ],
                "longitude": 118.03611,
                "latitude": 29.660185,
                "icon": "line/8/7.png",
                "icon_scale": 90,
                "wh": 2.782,
                "icon_longitude": 117.839428,
                "icon_latitude": 29.622399,
                "recommend": [
                    {
                        "name": "老电影院饺子店",
                        "tel": "0559-7535775",
                        "address": "休宁县萝宁街10号"
                    },
                    {
                        "name": "齐镇酒家",
                        "tel": "13733051633",
                        "address": "休宁县齐云山镇岩前街5号"
                    },
                    {
                        "name": "祥瑞轩餐厅",
                        "tel": "0559-2661688",
                        "address": "齐云山风景区索道北侧齐云小镇入口处"
                    },
                    {
                        "name": "齐云山白岳/月华酒店",
                        "tel": "0559-2661688",
                        "address": "齐云山风景区索道北侧齐云小镇入口处"
                    }
                ]
            }
        ]
    },
    {
        "id": 9,
        "name": "画里鸣禽·香樟古树摄影线",
        "center": [
            29.99396,
            117.831787
        ],
        "zoom": 9.9,
        "points": [
            {
                "s_id": "9_1",
                "name": "碧山工销社",
                "address": "黟县碧阳镇碧山村",
                "desc": "碧山工销社位于安徽省黄山市黟县碧山村，前身是碧山工销社原址为建于1962年的碧山供销社，同时也是村祠堂——尚义堂的遗址。\n改造于2015年5月，上海汉室设计管理机构正式租赁下碧山供销社并进行设计改造，将其命名为“碧山工销社”。\n2017年开业，碧山工销社重新开放，成为集出版、展览、零售、餐饮、住宿、驻村、研学等多项内容的综合文化空间。",
                "thumbs": [
                    "line/marker/9_1/碧山工销舍.jpg"
                ],
                "longitude": 117.912425,
                "latitude": 29.948763,
                "icon": "line/9/1.png",
                "icon_scale": 90,
                "wh": 1.682,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 117.81189,
                "icon_latitude": 29.981141,
                "recommend": [
                    {
                        "name": "我的收藏",
                        "tel": "19942593538",
                        "address": "碧阳镇碧山村(碧山书局对面)"
                    }
                ]
            },
            {
                "s_id": "9_2",
                "name": "卢村",
                "address": "黟县宏村镇卢村",
                "desc": "卢村位于安徽省南部黄山市境，又名雉山村，地处交通要道羊栈岭南侧。\n卢村文风昌盛，名人辈出，为官者很多。北宋太平兴国时期，卢储位至吏部尚书，文笔极佳，宋太宗誉其：“修饰润色，献纳论思，极一时之妙选，为儒者之至荣”；卢麟官至南宋绍兴年间左丞相，兼兵部侍郎；卢臣忠为北宋进士，历任显要，南宋高宗特赠谏议大夫，称赞他“介洁不群，端静有守，自居言责，达于闻听”。",
                "thumbs": [
                    "line/marker/9_2/卢村.jpg"
                ],
                "longitude": 117.975501,
                "latitude": 30.014711,
                "icon": "line/9/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.736877,
                "icon_latitude": 30.097696
            },
            {
                "s_id": "9_3",
                "name": "塔川",
                "address": "黄山市黟县Y102",
                "desc": "可观赏红嘴蓝鹊、画眉，闭上古树群、塔川景区古树群、乌桕桕文创美学空间",
                "thumbs": [
                    "line/marker/9_3/黟县-塔川.jpg",
                    "line/marker/9_3/黟县-塔川1.jpg",
                    "line/marker/9_3/黟县-塔川2.jpg",
                    "line/marker/9_3/黟县-塔川3.jpg"
                ],
                "longitude": 118.007538,
                "latitude": 30.01761,
                "id": 109,
                "icon": "line/9/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.898707,
                "icon_latitude": 30.077924
            },
            {
                "s_id": "9_4",
                "name": "协里田园",
                "address": "黟县宏村镇协里村",
                "desc": "协里村位于安徽省黄山市黟县宏村镇，处在宏村塔川东向1公里处，距黟县县城13公里。\n协里村是郑氏家族村，全村97.7%以上村民都姓郑。\n协里村由两个自然村构成，两个自然村遥相呼应，点缀在青山绿野之中。",
                "thumbs": [
                    "line/marker/9_4/协里田园.jpg"
                ],
                "longitude": 118.005628,
                "latitude": 29.991934,
                "icon": "line/9/4.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.966421,
                "icon_latitude": 29.964512
            },
            {
                "s_id": "9_5",
                "name": "木坑竹海",
                "address": "黟县宏村镇星光村",
                "desc": "可观赏竹鸡、棕头鸦雀，属于《卧虎藏龙》取景地，可品尝竹筒饭",
                "thumbs": [
                    "line/marker/9_5/黟县-木坑竹海.jpg",
                    "line/marker/9_5/黟县-木坑竹海1.jpg"
                ],
                "longitude": 118.025693,
                "latitude": 29.997202,
                "id": 107,
                "icon": "line/9/5.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.05371,
                "icon_latitude": 30.000941
            },
            {
                "s_id": "9_6",
                "name": "芳村",
                "address": "祁门县祁山镇芳村",
                "desc": "芳村村依山傍水，村内地势平坦宽阔，四面青山环绕，清澈的芳六河沿村而过，森林覆盖率超过90%，有着“晴时早晚遍地雾，阴雨成天满山云”的天然氧吧之称。优美的生态环境使得村域内有着丰富的鸟类品种，目前已拍摄到的鸟类有46种，其中国家二级保护鸟类9种、三级保护鸟类37种。夏季，还可观赏百亩荷花。",
                "thumbs": [
                    "line/marker/9_6/芳村.jpg"
                ],
                "longitude": 117.704758,
                "latitude": 29.894266,
                "icon": "line/9/6.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.697819,
                "icon_latitude": 29.86972
            },
            {
                "s_id": "9_7",
                "name": "石迹村观鸟基地",
                "address": "祁门县历口镇石迹村观鸟基地",
                "desc": "该点位可观测到40余种鸟类，其中包括白鹇、白颈长尾雉、红嘴蓝鹊等，以白鹇为主，总体数量有百余只。\n白鹇为晨昏活动，因此可选择全年的早上7-9时以及下午4-6时进行观鸟和拍摄。",
                "thumbs": [
                    "line/marker/9_7/石迹村观鸟基地.jpg"
                ],
                "longitude": 117.532098,
                "latitude": 29.866307,
                "icon": "line/9/7.png",
                "icon_scale": 90,
                "wh": 1.243,
                "icon_longitude": 117.532098,
                "icon_latitude": 29.866307
            },
            {
                "s_id": "9_8",
                "name": "历溪御医古村",
                "address": "祁门县历口镇历溪村",
                "desc": "可观赏千年樟树、大峡谷",
                "thumbs": [
                    "line/marker/9_8/祁门-历溪.jpg",
                    "line/marker/9_8/祁门-历溪1.jpg",
                    "line/marker/9_8/祁门-历溪2.jpg",
                    "line/marker/9_8/祁门-历溪3.jpg"
                ],
                "longitude": 117.498804,
                "latitude": 29.980079,
                "id": 110,
                "icon": "line/9/8.png",
                "icon_scale": 90,
                "wh": 1.1,
                "icon_longitude": 117.498981,
                "icon_latitude": 29.995184
            },
            {
                "s_id": "9_9",
                "name": "历溪村",
                "address": "祁门县历口镇历溪村",
                "desc": "可观赏千年樟树、大峡谷",
                "thumbs": [
                    "line/marker/9_9/祁门-历溪.jpg",
                    "line/marker/9_9/祁门-历溪1.jpg",
                    "line/marker/9_9/祁门-历溪2.jpg",
                    "line/marker/9_9/祁门-历溪3.jpg"
                ],
                "longitude": 117.498804,
                "latitude": 29.980079,
                "id": 110,
                "icon": "line/9/9.png",
                "icon_scale": 90,
                "wh": 1.623,
                "icon_longitude": 117.395819,
                "icon_latitude": 29.873314,
                "recommend": [
                    {
                        "name": "沐心·弈园",
                        "tel": "13399598480",
                        "address": "祁门县历口镇西塘村"
                    }
                ]
            }
        ]
    },
    {
        "id": 10,
        "name": "松涛鸟韵·黄山风光摄影线",
        "center": [
            30.18396,
            118.221787
        ],
        "zoom": 10.13,
        "points": [
            {
                "s_id": "10_1",
                "name": "黄山风景区南大门",
                "address": "黄山区汤口镇 205 国道",
                "desc": "可观赏猴谷鸮类 、光明顶雀类；天都峰棕噪鹛、光明顶雀类；迎客松、梦笔生花、红嘴相思鸟，打卡西海小火车，南门下、梦笔生花、红嘴相思鸟，打卡西海小火车",
                "thumbs": [
                    "line/marker/10_1/黄山区-黄山风景区.jpg",
                    "line/marker/10_1/黄山区-黄山风景区1.jpg",
                    "line/marker/10_1/黄山区-黄山风景区2.jpg"
                ],
                "longitude": 118.170467,
                "latitude": 30.126561,
                "id": 71,
                "icon": "line/10/1.png",
                "icon_scale": 90,
                "wh": 1.393,
                "icon_longitude": 118.198084,
                "icon_latitude": 30.010319
            },
            {
                "s_id": "10_2",
                "name": "云谷寺景观区",
                "address": "黄山风景区",
                "desc": "云谷寺景观区（云谷景区位于黄山东部，上至白鹅岭，下到九龙瀑，平均海拔900米左右。。可达景点有狮子抢球、千古石、仙人榜、丞相源、灵锡泉、江丽田琴台、梅屋、丞相桥、九龙瀑等。可望景点主要有钵盂峰、眉毛峰、香炉峰、罗汉峰等。）",
                "thumbs": [
                    "line/marker/10_2/黄山地质公园博物馆（位于云谷寺景观区）.JPG"
                ],
                "longitude": 118.193093,
                "latitude": 30.11978,
                "icon": "line/10/2.png",
                "icon_scale": 90,
                "wh": 1.075,
                "icon_longitude": 118.263318,
                "icon_latitude": 30.152155
            },
            {
                "s_id": "10_3",
                "name": "云谷索道上行",
                "address": "黄山风景区",
                "desc": "云谷索道上行",
                "thumbs": [
                    "line/marker/10_3/云谷索道.jpg"
                ],
                "longitude": 118.194261,
                "latitude": 30.120611,
                "icon": "line/10/3.png",
                "icon_scale": 90,
                "wh": 1.084,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.244641,
                "icon_latitude": 30.282787
            },
            {
                "s_id": "10_4",
                "name": "始信峰景观区",
                "address": "黄山风景区",
                "desc": "观赏竖琴松、探海松、接引松、卧龙松、龙爪松、黑虎松、雨伞松（位于北海景区，相传旧时有人从云谷寺漫游至此，如入画境，似幻而真，始信黄山风景奇绝，遂名“始信峰”。因众多名松都在该峰或在附近，故民谚有“不到始信峰，不见黄山松”之说。）",
                "thumbs": [
                    "line/marker/10_4/始信峰 方玉霞 摄（始信峰景观区）.jpg"
                ],
                "longitude": 118.174747,
                "latitude": 30.141666,
                "icon": "line/10/4.png",
                "icon_scale": 90,
                "wh": 1.093,
                "icon_longitude": 118.17822,
                "icon_latitude": 30.345561
            },
            {
                "s_id": "10_5",
                "name": "狮子峰景观区",
                "address": "黄山风景区",
                "desc": "观赏仙鹤松、梦笔生花，白鹇、红嘴相思鸟、棕噪鹛（位于北海景区，东邻始信峰，南对贡阳山，整座山峰如雄狮横卧，头西尾东。附近有“麒麟松”、“凤凰柏”。这一带可看“十八罗汉朝南海”、“仙人下棋”、“丞相观棋”、“仙人背包”、“猴子观海”等。由于景点多而集中，故有“不到狮子峰，不见黄山踪”的旅游谚语。在峰腰清凉台附近岩壁上，有“清凉世界”、“万壑幽邃”、“险幻奇伟”、“灵幻奇秀”等石刻。）",
                "thumbs": [
                    "line/marker/10_5/猴子观海 侯瑞冬 摄（狮子峰上远眺）.jpg"
                ],
                "longitude": 118.170289,
                "latitude": 30.14464,
                "icon": "line/10/5.png",
                "icon_scale": 90,
                "wh": 1.109,
                "icon_longitude": 118.081987,
                "icon_latitude": 30.345561
            },
            {
                "s_id": "10_6",
                "name": "排云亭景观区",
                "address": "黄山风景区",
                "desc": "排云亭景观区（排云景观区位于西海门，这里面对群峰大壑，视野开阔，是观赏黄山秀色最佳处之一:俯瞰，是深广的西海峡谷;仰视，是并列的西海峰林。附近的岩石景观非常独特，例如\"仙人晒靴\"和\"仙人晒鞋\"、\"天女弹琴\"等，展现了大自然的鬼斧神工。）",
                "thumbs": [
                    "line/marker/10_6/排云亭 陈自银 摄（排云亭景观区）.jpg"
                ],
                "longitude": 118.161581,
                "latitude": 30.140201,
                "icon": "line/10/6.png",
                "icon_scale": 90,
                "wh": 1.093,
                "icon_longitude": 117.977125,
                "icon_latitude": 30.33264
            },
            {
                "s_id": "10_7",
                "name": "飞来石",
                "address": "黄山风景区",
                "desc": "飞来石（在天海平天矼西端的峰头上，有一巨石耸立。石呈近长方柱体，耸立在峰头基岩平台之上，如此巨石与基岩接触面却很小，就好像从天外飞来，故名“飞来石”。）",
                "thumbs": [
                    "line/marker/10_7/飞来石 操文明 摄（飞来石）.jpg"
                ],
                "longitude": 118.163971,
                "latitude": 30.135576,
                "icon": "line/10/7.png",
                "icon_scale": 90,
                "wh": 2.24,
                "icon_longitude": 117.989834,
                "icon_latitude": 30.260435,
                "recommend": [
                    {
                        "name": "山顶酒店雲野@排云型旅",
                        "tel": "0559-2590999\n",
                        "address": "黄山风景区西海景区丹霞峰下"
                    },
                    {
                        "name": "黄山西海饭店",
                        "tel": "0559-2590999",
                        "address": "黄山风景区西海饭店"
                    }
                ]
            },
            {
                "s_id": "10_8",
                "name": "西海大峡谷景观区",
                "address": "黄山风景区",
                "desc": "西海观光缆车，观赏凤头鹰、松雀鹰（西海大峡谷又被称为梦幻景区，大峡谷位于西海群峰中，北起西海排云亭，南至白云景区步仙桥，其内“千峰划然开，紫翠呈万状”，奇松林立，巧石如林，山高谷深，云雾缭绕，清泉叮咚，大峡谷更多的是探幽，所谓“横看成岭侧成峰，远近高低各不同”，“不知峡谷真面目，只缘身在此山中”的意境在大峡谷中表现的淋漓尽致。）",
                "thumbs": [
                    "line/marker/10_8/西海大峡谷 张希 摄（西海大峡谷景观区）.jpg"
                ],
                "longitude": 118.156824,
                "latitude": 30.132934,
                "icon": "line/10/8.png",
                "icon_scale": 90,
                "wh": 1.393,
                "icon_longitude": 117.941863,
                "icon_latitude": 30.136817
            },
            {
                "s_id": "10_9",
                "name": "光明顶",
                "address": "黄山区汤口镇 205 国道",
                "desc": "可观赏猴谷鸮类 、光明顶雀类；天都峰棕噪鹛、光明顶雀类；迎客松、梦笔生花、红嘴相思鸟，打卡西海小火车，南门下、梦笔生花、红嘴相思鸟，打卡西海小火车",
                "thumbs": [
                    "line/marker/10_9/黄山区-黄山风景区.jpg",
                    "line/marker/10_9/黄山区-黄山风景区1.jpg",
                    "line/marker/10_9/黄山区-黄山风景区2.jpg"
                ],
                "longitude": 118.170467,
                "latitude": 30.126561,
                "id": 71,
                "icon": "line/10/9.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.05334,
                "icon_latitude": 30.188704
            },
            {
                "s_id": "10_10",
                "name": "天海景观区",
                "address": "黄山风景区",
                "desc": "鳌鱼峰，观赏凤凰松（天海景观区位于黄山风景区的中心地带，天海四周被群峰环绕，地势开阔，是观赏黄山奇峰怪石、云雾缭绕景象的理想之地。）",
                "thumbs": [
                    "line/marker/10_10/鳌鱼驮金龟 迟名尊 摄（天海景观区）.jpg"
                ],
                "longitude": "118.169186",
                "latitude": "30.132266",
                "icon": "line/10/10.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.032028,
                "icon_latitude": 30.086403
            },
            {
                "s_id": "10_11",
                "name": "黄山风景区",
                "address": "黄山区汤口镇 205 国道",
                "desc": "可观赏猴谷鸮类 、光明顶雀类；天都峰棕噪鹛、光明顶雀类；迎客松、梦笔生花、红嘴相思鸟，打卡西海小火车，南门下、梦笔生花、红嘴相思鸟，打卡西海小火车",
                "thumbs": [
                    "line/marker/10_11/黄山区-黄山风景区.jpg",
                    "line/marker/10_11/黄山区-黄山风景区1.jpg",
                    "line/marker/10_11/黄山区-黄山风景区2.jpg"
                ],
                "longitude": 118.170467,
                "latitude": 30.126561,
                "id": 71,
                "icon": "line/10/11.png",
                "icon_scale": 90,
                "wh": 1.078,
                "icon_longitude": 118.140737,
                "icon_latitude": 30.115915
            },
            {
                "s_id": "10_12",
                "name": "玉屏索道下行",
                "address": "黄山风景区",
                "desc": "玉屏索道下行",
                "thumbs": [
                    "line/marker/10_12/人字瀑 （位于玉屏索道下行）.JPG"
                ],
                "longitude": 118.17065,
                "latitude": 30.142184,
                "icon": "line/10/12.png",
                "icon_scale": 90,
                "wh": 1.14,
                "icon_longitude": 118.130056,
                "icon_latitude": 30.038305
            }
        ]
    },
    {
        "id": 11,
        "name": "探密谜窟 自然历史穿越之旅",
        "center": [
            29.737359,
            118.321787
        ],
        "zoom": 10.68,
        "points": [
            {
                "s_id": "11_1",
                "name": "花山谜窟",
                "address": "黄山市屯溪区花山路",
                "desc": "属于研学基地，可体验沉浸式探秘游",
                "thumbs": [
                    "line/marker/11_1/00bccf8f80f4c254fbe35ec7538dc2c.jpg",
                    "line/marker/11_1/654c1a3ae8c1c26a8d50c61a778d52f.jpg",
                    "line/marker/11_1/903ded8cc7c6d6af67974c1e7469fb5.jpg"
                ],
                "longitude": 118.389019,
                "latitude": 29.744423,
                "id": 35,
                "icon": "line/11/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.38375,
                "icon_latitude": 29.63751
            },
            {
                "s_id": "11_2",
                "name": "南溪南村",
                "address": "黄山市屯溪区屯光镇南溪南村",
                "desc": "南溪南村位于屯溪东郊，新安江南岸，是一个千年古村落。村内有古民居36幢，明清牌坊共2座，坐拥摩崖石刻等众多元、明、清时期石刻，文化资源禀赋深厚。南溪南将豆腐产业与乡村旅游、文化创意等产业相结合，村庄内的豆腐作坊进行了绿色升级，积极引进新业态，如乡野咖啡、特色美食、文创文展等。",
                "thumbs": [
                    "line/marker/11_2/南溪南村.JPG"
                ],
                "longitude": 118.364851,
                "latitude": 29.75109,
                "icon": "line/11/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.405291,
                "icon_latitude": 29.686325
            },
            {
                "s_id": "11_3",
                "name": "篁墩村",
                "address": "黄山市屯溪区屯光镇篁墩村",
                "desc": "篁墩村距今近2000年历史，与山西省洪洞县大槐树村、福建省宁化县石壁村共称中国三大宗族始迁地，也是新安理学奠基人程颢、程颐和集大成者朱熹的祖居地，素有“东南邹鲁”之称，被学术界尊称为 “徽州文化第一村”，现有古延寿桥、乐泉桥、六合桥等明清古桥和“洛闽溯本”牌坊、程氏统宗祠等历史遗址。",
                "thumbs": [
                    "line/marker/11_3/篁墩村.png"
                ],
                "longitude": 118.366305,
                "latitude": 29.76649,
                "icon": "line/11/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.407761,
                "icon_latitude": 29.744985
            },
            {
                "s_id": "11_4",
                "name": "程氏三宅",
                "address": "屯溪区柏树街程氏三宅28号宅后院",
                "desc": "三级古树，树高8米，树围50厘米，冠幅6*8米，树龄285年，这株罗汉松在程氏三宅后院中挺拔了280多年，如今老树发新枝，越发的茂盛，枝干苍劲有力，叶片翠绿欲滴。程氏三宅作为第五批全国重点文物保护单位，结构严谨，装饰精美，古朴素雅。罗汉松默默注视着200多年的风云变幻，是程氏三宅中一道亮丽的风景线。美食推荐：步行大润发商业街夜市，集合各地小吃，如徽州臭豆腐、黄豆肉馃，边走边吃，纵享美味。",
                "thumbs": [
                    "marker/21/21-屯溪区程氏三宅罗汉松.jpg"
                ],
                "longitude": "118.3142302",
                "latitude": "29.711838",
                "icon": "line/11/4.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.35022,
                "icon_latitude": 29.72851
            },
            {
                "s_id": "11_5",
                "name": "屯溪老街",
                "address": "屯溪区屯溪老街",
                "desc": "可观赏流动着的清明上河图",
                "thumbs": [
                    "line/marker/11_5/屯溪区-屯溪老街.JPG",
                    "line/marker/11_5/屯溪区-屯溪老街1.jpg"
                ],
                "longitude": 118.307321,
                "latitude": 29.708422,
                "id": 66,
                "icon": "line/11/5.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.300426,
                "icon_latitude": 29.739638
            },
            {
                "s_id": "11_6",
                "name": "安徽中国徽州文化博物馆",
                "address": "安徽中国徽州文化博物馆",
                "desc": "安徽中国徽州文化博物馆位于黄山市屯溪迎宾大道50号，国家一级博物馆 ，馆藏近10万件文物，以徽墨、歙砚等为特色。馆内依《徽州人与徽州文化》设多个展厅，全面展现徽州历史与文化魅力。",
                "thumbs": [
                    "line/marker/11_6/徽州文化博物馆.jpg"
                ],
                "longitude": 118.274611,
                "latitude": 29.717693,
                "icon": "line/11/6.png",
                "icon_scale": 90,
                "wh": 3.153,
                "icon_longitude": 118.236274,
                "icon_latitude": 29.688659,
                "recommend": [
                    {
                        "name": "中国徽菜博物馆",
                        "tel": "0559-2333777",
                        "address": "屯溪区迎宾大道62号"
                    },
                    {
                        "name": "还淳度假",
                        "tel": "17355951656",
                        "address": "屯溪区屯溪老街还淳巷9号"
                    },
                    {
                        "name": "蔓园见山",
                        "tel": "13365597933",
                        "address": "徽州区西溪南镇西溪南村十字街3号"
                    },
                    {
                        "name": "山水间·微酒店",
                        "tel": "13855957585",
                        "address": "滨江东路湖边古村落7号楼"
                    }
                ]
            },
            {
                "s_id": "11_7",
                "name": "傍霞村观鸟基地",
                "address": "屯溪区黎阳镇鬲山大道19号",
                "desc": "这里树荫茂密，有鸟类 30 余种，重点观赏具有福寿寓意的寿带鸟。村里专门设置了保护屏障与告示牌，保护了400余亩茶园、林地，为鸟类提供了优良栖息空间。沿着铺设好的步行道沉浸式观鸟赏景，可使用观鸟屋、远程监控等设施，还能在观鸟景观台及观赏点全方位观察鸟类。",
                "thumbs": [
                    "line/marker/11_7/12傍霞村观鸟基地.png"
                ],
                "longitude": 118.258492,
                "latitude": 29.675683,
                "icon": "line/11/7.png",
                "icon_scale": 90,
                "wh": 1.075,
                "icon_longitude": 118.304048,
                "icon_latitude": 29.639359
            },
            {
                "s_id": "11_8",
                "name": "唐模",
                "address": "黄山市徽州区潜口镇唐模村潜唐路1号",
                "desc": "可观赏古银杏、水口园林，观赏槐荫树，研学基地，唐朝模范村，赏古银杏",
                "thumbs": [
                    "line/marker/11_8/唐模晒秋 (2).jpg",
                    "line/marker/11_8/唐模晒秋 (3).jpg",
                    "line/marker/11_8/唐模晒秋 (4).jpg",
                    "line/marker/11_8/唐模晒秋.jpg"
                ],
                "longitude": 118.336109,
                "latitude": 29.868462,
                "id": 132,
                "icon": "line/11/8.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.32975,
                "icon_latitude": 29.84671
            }
        ]
    },
    {
        "id": 12,
        "name": "雕梁画栋  非遗生态研习之旅",
        "center": [
            29.841359,
            118.631787
        ],
        "zoom": 10.3,
        "points": [
            {
                "s_id": "12_1",
                "name": "徽字号",
                "address": "安徽省黄山市屯溪区高新科技开发区梅林大道88号",
                "desc": "徽字号徽雕艺术博物馆以“保护徽雕文物，传承徽雕技艺，弘扬徽州文化\"为宗旨，以国家级非遗项目“徽州三雕”、“徽州竹雕”的传习传承为使命，先后被评为安徽省优秀研学基地、安徽省非遗传承基地、、安徽省文化产业示范基地、安徽省研学旅游示范基地、黄山市研学教育基地、黄山市爱国主义教育基地。",
                "thumbs": [
                    "line/marker/12_1/徽字号.jpg"
                ],
                "longitude": 118.267188,
                "latitude": 29.790217,
                "icon": "line/12/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.305657,
                "icon_latitude": 29.739934
            },
            {
                "s_id": "12_2",
                "name": "雄村",
                "address": "歙县雄村",
                "desc": "可体验竹筏、竹山书院",
                "thumbs": [
                    "line/marker/12_2/歙县-雄村.JPG",
                    "line/marker/12_2/歙县-雄村2.jpg"
                ],
                "longitude": 118.443313,
                "latitude": 29.815761,
                "id": 85,
                "icon": "line/12/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.542948,
                "icon_latitude": 29.710409
            },
            {
                "s_id": "12_3",
                "name": "义成村",
                "address": "歙县雄村镇义成村",
                "desc": "歙县义成村有一棵古老樟树，位于村口，斑驳的树身布满青苔，需五六人牵手合围，树干4米以下形成了独特的树洞，洞里可同时站立四五个成年人。当地人称为“茂荫古樟”，据说，马克思《资本论》中唯一提到的中国人—王茂荫（清代，1798年-1865年），晚年定居义成后，每逢客人到访，迎来送往，必在此樟树下；几百年来，这株古樟历经四季更迭、沧桑岁月和历史变迁，为村民遮风挡雨，护佑着村庄的平安与祥和，让人很生敬畏。",
                "thumbs": [
                    "line/marker/12_3/义成村1.jpg",
                    "line/marker/12_3/义成村2.jpg"
                ],
                "longitude": 118.444104,
                "latitude": 29.828342,
                "icon": "line/12/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.611409,
                "icon_latitude": 29.751174
            },
            {
                "s_id": "12_4",
                "name": "棠樾牌坊群",
                "address": "歙县郑村镇棠樾村",
                "desc": "可体验探寻七座牌坊的故事，观赏《棠樾之礼》等演出、徽派盆景",
                "thumbs": [
                    "line/marker/12_4/歙县-鲍家花园.jpg",
                    "line/marker/12_4/歙县-鲍家花园1.jpg",
                    "line/marker/12_4/歙县-鲍家花园2.jpg"
                ],
                "longitude": 118.369767,
                "latitude": 29.866902,
                "id": 88,
                "icon": "line/12/4.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.385302,
                "icon_latitude": 29.944152
            },
            {
                "s_id": "12_5",
                "name": "鲍家花园",
                "address": "歙县郑村镇棠樾村",
                "desc": "这里的鲍家花园改简介为   漫步“东方园林之母”鲍家花园，欣赏被誉为“无声的诗，立体的画”的徽派盆景。园内亭台楼阁、小桥流水，绿意盎然。盆景造型各异，巧夺天工，令人叹为观止。",
                "thumbs": [
                    "line/marker/12_5/歙县-鲍家花园.jpg",
                    "line/marker/12_5/歙县-鲍家花园1.jpg",
                    "line/marker/12_5/歙县-鲍家花园2.jpg"
                ],
                "longitude": 118.369767,
                "latitude": 29.866902,
                "id": 88,
                "icon": "line/12/5.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.472282,
                "icon_latitude": 29.95296
            },
            {
                "s_id": "12_6",
                "name": "徽州古城",
                "address": "黄山市歙县徽城镇徽州古城景区",
                "desc": "属于研学基地，徽州府衙，可探寻古徽州文化，可观赏沉浸式演出、安徽徽州历史博物馆",
                "thumbs": [
                    "line/marker/12_6/3fb1c60d613135fc36337e1f51cd133.jpg",
                    "line/marker/12_6/ae5d9f1fb9ae471e3b112ab056fc07a.jpg",
                    "line/marker/12_6/dee2d4c64eaea002b442899f0503ffe.jpg"
                ],
                "longitude": 118.436772,
                "latitude": 29.86602,
                "id": 146,
                "icon": "line/12/6.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.56708,
                "icon_latitude": 29.888976
            },
            {
                "s_id": "12_7",
                "name": "渔梁村",
                "address": "歙县徽城镇渔梁村",
                "desc": "渔梁坝是我国古代杰出的水利工程，也是新安江上游最古老、规模最大的拦河坝，被古建筑专家郑孝燮先生誉为“江南都江堰”，2001年被国务院批准为第五批全国重点文物保护单位。渔梁坝的一端就是渔梁古街。当年的商人、水手、脚夫和往来客人云集渔梁，从而形成一条渔梁商业街。街道两旁店面一色木板房，灰墙青瓦，古色古香，徽韵醇浓的古店号、古庄号至今依稀可见。行走其间仿佛又回到明清时期繁荣的街市。",
                "thumbs": [
                    "line/marker/12_7/43 渔梁村.JPG",
                    "line/marker/12_7/渔梁村1.jpg",
                    "line/marker/12_7/渔梁村2.jpg"
                ],
                "longitude": 118.44968,
                "latitude": 29.857473,
                "icon": "line/12/7.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.665241,
                "icon_latitude": 29.859986
            },
            {
                "s_id": "12_8",
                "name": "瞻淇村",
                "address": "歙县北岸镇瞻淇村",
                "desc": "瞻淇村，村名“瞻淇”取自于《诗经·卫风》“瞻彼淇奥，绿竹猗猗”，至今已有1300多年历史。瞻淇鱼灯起源于宋代，至今已有800多年历史。宋代宋理宗时，瞻淇人丁兴旺，代代有官，以北京兵马总司汪翥，江苏县令汪鸿澡，江西九江府府台汪作霖为首，在村里兴起元宵节花灯，传承至今。每年正月初二至正月十八，村里都会举办盛大的嬉鱼灯会。",
                "thumbs": [
                    "line/marker/12_8/44 瞻淇村.jpg",
                    "line/marker/12_8/瞻淇村.jpg"
                ],
                "longitude": 118.520436,
                "latitude": 29.872633,
                "icon": "line/12/8.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.768979,
                "icon_latitude": 29.88801
            },
            {
                "s_id": "12_9",
                "name": "深渡码头",
                "address": "歙县深渡镇深渡码头",
                "desc": "深渡码头是古徽州重要的水上交通枢纽，是众多徽商下苏杭、去京城等地的始发地，见证了徽商的徽杭，也孕育了深渡老街等历史文化景点",
                "thumbs": [
                    "line/marker/12_9/深渡码头.jpg",
                    "line/marker/12_9/深渡码头2.jpg",
                    "line/marker/12_9/深渡码头3.jpg"
                ],
                "longitude": 118.618353,
                "latitude": 29.862479,
                "icon": "line/12/9.png",
                "icon_scale": 90,
                "wh": 2.638,
                "icon_longitude": 118.848176,
                "icon_latitude": 29.956587,
                "recommend": [
                    {
                        "name": "钵头食府",
                        "tel": "0559-6810272",
                        "address": "歙县深渡镇黄山大道25号"
                    },
                    {
                        "name": "千百渡生态农庄",
                        "tel": "0559-2751616 ",
                        "address": "歙县深渡镇大茂村1号"
                    },
                    {
                        "name": "金丸岛·江深草阁",
                        "tel": "18155965088",
                        "address": "歙县绵潭村将军埠1号"
                    }
                ]
            }
        ]
    },
    {
        "id": 13,
        "name": "千年古韵 红茶文化研学之旅",
        "center": [
            29.837359,
            117.791787
        ],
        "zoom": 10.2,
        "points": [
            {
                "s_id": "13_1",
                "name": "宏村",
                "address": "黟县宏村",
                "desc": "可观赏牛角红杨，《宏村阿菊》演出、南湖赏荷",
                "thumbs": [
                    "line/marker/13_1/黟县-宏村.jpg",
                    "line/marker/13_1/黟县-宏村1.jpg",
                    "line/marker/13_1/黟县-宏村2.jpg"
                ],
                "longitude": 117.990001,
                "latitude": 30.002422,
                "id": 100,
                "icon": "line/13/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.989956,
                "icon_latitude": 30.002582
            },
            {
                "s_id": "13_2",
                "name": "塔川",
                "address": "黄山市黟县Y102",
                "desc": "可观赏红嘴蓝鹊、画眉，闭上古树群、塔川景区古树群、乌桕桕文创美学空间",
                "thumbs": [
                    "line/marker/13_2/黟县-塔川.jpg",
                    "line/marker/13_2/黟县-塔川1.jpg",
                    "line/marker/13_2/黟县-塔川2.jpg",
                    "line/marker/13_2/黟县-塔川3.jpg"
                ],
                "longitude": 118.007538,
                "latitude": 30.01761,
                "id": 109,
                "icon": "line/13/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.063277,
                "icon_latitude": 29.995976
            },
            {
                "s_id": "13_3",
                "name": "西汉广德王国古都",
                "address": "黟县城东古城",
                "desc": "位于黟县古城区，于2020年正式对外开放，是在原址上抢救、恢复的古城景区。西汉广德国都景区内两条主要街道为主轴，有汉唐风格城墙、城楼、酒楼、以及县衙、城隍庙、钱庄、当铺、汉服店等古代都市景象，还有占地面积十多亩的东湖，既可以观光又可拍照打卡。",
                "thumbs": [
                    "line/marker/13_3/西汉广德王国.jpg"
                ],
                "longitude": 117.961303,
                "latitude": 29.929561,
                "icon": "line/13/3.png",
                "icon_scale": 90,
                "wh": 1.505,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 117.961303,
                "icon_latitude": 29.929561
            },
            {
                "s_id": "13_4",
                "name": "碧山村",
                "address": "黄山市黟县碧山镇碧山村云贤研学旅游服务有限公司",
                "desc": "可体验鱼灯、咖啡、书局",
                "thumbs": [
                    "line/marker/13_4/微信图片_20240502120741.jpg",
                    "line/marker/13_4/微信图片_20240502120745.jpg",
                    "line/marker/13_4/微信图片_20240502120749.jpg"
                ],
                "longitude": 117.91489,
                "latitude": 29.953286,
                "id": 62,
                "icon": "line/13/4.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.842106,
                "icon_latitude": 29.979424
            },
            {
                "s_id": "13_5",
                "name": "丰梧村",
                "address": "黟县碧阳镇丰梧村",
                "desc": "距离县城5.5公里，近年来利用“乡村记忆博物馆、水渠廊桥、朴蔓农场、”等特色空间改造带动文旅发展，作为皖南旅游线路节点，丰梧村融合自然景观与文化体验，吸引游客的同时提升村民生活品质。",
                "thumbs": [
                    "line/marker/13_5/丰梧村.jpg"
                ],
                "longitude": 117.893563,
                "latitude": 29.94108,
                "icon": "line/13/5.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.865448,
                "icon_latitude": 29.889939
            },
            {
                "s_id": "13_6",
                "name": "南屏村",
                "address": "黟县碧阳镇南屏村",
                "desc": "可观赏香樟树、古巷迷宫",
                "thumbs": [
                    "line/marker/13_6/黟县-南屏.jpg",
                    "line/marker/13_6/黟县-南屏1.jpg",
                    "line/marker/13_6/黟县-南屏2.jpg",
                    "line/marker/13_6/黟县-南屏3.jpg"
                ],
                "longitude": 117.905067,
                "latitude": 29.898719,
                "id": 104,
                "icon": "line/13/6.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.961927,
                "icon_latitude": 29.810887
            },
            {
                "s_id": "13_7",
                "name": "西递村",
                "address": "黄山市黟县西递镇西递村",
                "desc": "可观赏近景徽剧、水幕光影秀",
                "thumbs": [
                    "line/marker/13_7/微信图片_20220924210724汪洪.jpg",
                    "line/marker/13_7/微信图片_20221013113227汪洪 (5).jpg",
                    "line/marker/13_7/汪洪晒秋1.jpg"
                ],
                "longitude": 117.99599,
                "latitude": 29.90334,
                "id": 129,
                "icon": "line/13/7.png",
                "icon_scale": 90,
                "wh": 1.95,
                "icon_longitude": 118.040543,
                "icon_latitude": 29.879807,
                "recommend": [
                    {
                        "name": "黟县徽娘私房菜",
                        "tel": "15305591184",
                        "address": "黟县西递镇西递景区内"
                    },
                    {
                        "name": "黟县得意楼",
                        "tel": "0559-5558678",
                        "address": "黟县碧山路097号"
                    },
                    {
                        "name": "西递泊心云舍酒店",
                        "tel": "15095227799",
                        "address": "黟县西递001号"
                    }
                ]
            },
            {
                "s_id": "13_8",
                "name": "祥源·祁红产业文化博览园",
                "address": "祁门县华扬工业园区祥源祁红产业文化博览园",
                "desc": "可体验红茶制作",
                "thumbs": [
                    "line/marker/13_8/祁门-祥源·祁红文化产业博览园.jpg",
                    "line/marker/13_8/祁门-祥源·祁红文化产业博览园1.jpg",
                    "line/marker/13_8/祁门-祥源·祁红文化产业博览园2.jpg"
                ],
                "longitude": 117.749542,
                "latitude": 29.842768,
                "id": 111,
                "icon": "line/13/8.png",
                "icon_scale": 90,
                "wh": 1.888,
                "icon_longitude": 117.547448,
                "icon_latitude": 29.866329
            },
            {
                "s_id": "13_9",
                "name": "平里祁红小镇",
                "address": "祁门县平里镇平里村",
                "desc": "黄山市首批特色小镇，祁门红茶发源地，万里茶道申遗点。拥有茶文化遗址、祁红5G智能化生产车间、梅南公园、生态茶园等文旅资源，是茶文旅融合绝佳旅游目的地。",
                "thumbs": [
                    "line/marker/13_9/平里小镇.jpg"
                ],
                "longitude": 117.60918,
                "latitude": 29.7324198,
                "icon": "line/13/9.png",
                "icon_scale": 90,
                "wh": 1.084,
                "icon_longitude": 117.613843,
                "icon_latitude": 29.734488
            },
            {
                "s_id": "13_10",
                "name": "芦溪村",
                "address": "祁门县芦溪乡芦溪村",
                "desc": "水韵芦溪有着极为丰富的生态旅游资源，可谓是山高林密云海纵深，这里有倒湖十八湾、碧桃楠木林，还是安茶的发源地，现为中国安茶之乡。村内的茶园层层叠叠随处可见，起伏的山峦、清澈的溪流等自然景观宛如一幅幅动人的诗画江南图。",
                "thumbs": [
                    "line/marker/13_10/芦溪村.jpg"
                ],
                "longitude": 117.492309,
                "latitude": 29.69206,
                "icon": "line/13/10.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.511317,
                "icon_latitude": 29.697424
            },
            {
                "s_id": "13_11",
                "name": "渚口村",
                "address": "祁门县渚口乡大北村滩下组",
                "desc": "渚口乡滩下古树林藏于皖南山水间，林中树龄超百年的古树达30余株，其中多株枫杨、香樟被列为国家二级保护植物，枝繁叶茂的古银杏更是省级保护古树，堪称“天然活化石群落”。\n古树林周边紧邻渚口古村落景区，漫步可赏明清徽派建筑：贞一堂、一府六县；美食推荐“板栗烧鸡”、灯笼辣椒，鲜醇滋味融入山林气息，让人流连忘返。",
                "thumbs": [
                    "line/marker/13_11/渚口村.jpg"
                ],
                "longitude": 117.494708,
                "latitude": 29.846229,
                "icon": "line/13/11.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.415306,
                "icon_latitude": 29.815822
            },
            {
                "s_id": "13_12",
                "name": "历溪村",
                "address": "祁门县历口镇历溪村",
                "desc": "可观赏千年樟树、大峡谷",
                "thumbs": [
                    "line/marker/13_12/祁门-历溪.jpg",
                    "line/marker/13_12/祁门-历溪1.jpg",
                    "line/marker/13_12/祁门-历溪2.jpg",
                    "line/marker/13_12/祁门-历溪3.jpg"
                ],
                "longitude": 117.498804,
                "latitude": 29.980079,
                "id": 110,
                "icon": "line/13/12.png",
                "icon_scale": 90,
                "wh": 2.112,
                "icon_longitude": 117.497256,
                "icon_latitude": 29.978091,
                "recommend": [
                    {
                        "name": "梅家埠酒家",
                        "tel": "13805592125",
                        "address": "祁门历口镇光辉村江村组1号"
                    },
                    {
                        "name": "五一桥饭店",
                        "tel": "13855940403",
                        "address": "祁门县历口镇五一桥"
                    },
                    {
                        "name": "历溪溪上溪客栈",
                        "tel": "17355932328",
                        "address": "祁门县历口镇历溪村"
                    },
                    {
                        "name": "沐心·弈园",
                        "tel": "13399598480",
                        "address": "祁门县历口镇西塘村"
                    }
                ]
            }
        ]
    },
    {
        "id": 14,
        "name": "鹤舞瑯梅 微景观造园之旅",
        "center": [
            29.84359,
            118.211787
        ],
        "zoom": 10.28,
        "points": [
            {
                "s_id": "14_1",
                "name": "安徽润一·锐蓝",
                "address": "黄山市休宁县东临溪镇黄山雾云间生态庄园",
                "desc": "属于研学基地，是世界技能大赛园艺等项目中国集训基地",
                "thumbs": [
                    "line/marker/14_1/1.jpg",
                    "line/marker/14_1/2.jpg",
                    "line/marker/14_1/3.jpg",
                    "line/marker/14_1/4.jpg"
                ],
                "longitude": 118.300744,
                "latitude": 29.651427,
                "id": 59,
                "icon": "line/14/1.png",
                "icon_scale": 90,
                "wh": 1.162,
                "icon_longitude": 118.299457,
                "icon_latitude": 29.673154
            },
            {
                "s_id": "14_2",
                "name": "齐云山",
                "address": "休宁县齐云山镇县城西侧",
                "desc": "可赏榔梅树",
                "thumbs": [
                    "line/marker/14_2/休宁县-齐云山.jpg",
                    "line/marker/14_2/休宁县-齐云山1.jpg",
                    "line/marker/14_2/休宁县-齐云山2.jpg"
                ],
                "longitude": 118.026066,
                "latitude": 29.812065,
                "id": 93,
                "icon": "line/14/2.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.036434,
                "icon_latitude": 29.809262
            },
            {
                "s_id": "14_3",
                "name": "齐云小镇",
                "address": "休宁县齐云小镇",
                "desc": "街长888米，建筑面积2.34万平方米，围绕养生健康、非遗技艺、健康养生、艺术文创、在地饮食、精品旅宿五大业态布局，让游客在观览齐云山过程中，体验非遗匠造技艺，感受非遗之美。",
                "thumbs": [
                    "line/marker/14_3/50 齐云小痕 (1).jpg",
                    "line/marker/14_3/50 齐云小痕 (2).jpg",
                    "line/marker/14_3/50 齐云小镇 (3).jpg",
                    "line/marker/14_3/50 齐云小镇.jpg"
                ],
                "longitude": 118.044315,
                "latitude": 29.815483,
                "icon": "line/14/4.png",
                "icon_scale": 90,
                "wh": 2.016,
                "icon_longitude": 118.094996,
                "icon_latitude": 29.869116,
                "recommend": [
                    {
                        "name": "祥瑞轩餐厅",
                        "tel": "0559-2661688",
                        "address": "齐云山风景区索道北侧齐云小镇入口处"
                    },
                    {
                        "name": "齐镇酒家",
                        "tel": "13733051633",
                        "address": "休宁县齐云山镇岩前街5号"
                    },
                    {
                        "name": "齐云山白岳/月华酒店",
                        "tel": "0559-2661688",
                        "address": "齐云山风景区索道北侧齐云小镇入口处"
                    }
                ]
            },
            {
                "s_id": "14_4",
                "name": "枧潭村",
                "address": "休宁县蓝田镇",
                "desc": "可观赏枧潭景区",
                "thumbs": [
                    "line/marker/14_4/休宁县-枧潭.jpg",
                    "line/marker/14_4/休宁县-枧潭1.JPG"
                ],
                "longitude": 118.072573,
                "latitude": 29.989555,
                "id": 99,
                "icon": "line/14/5.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.072573,
                "icon_latitude": 29.989555
            },
            {
                "s_id": "14_5",
                "name": "谢裕大茶博园",
                "address": "黄山市徽州区潜口镇谢裕大东路99号",
                "desc": "属于研学基地，可体验以徽茶文化为核心的旅游，包括黄山毛峰品鉴、游乐项目等",
                "thumbs": [
                    "line/marker/14_5/微信图片_20240502093234.jpg",
                    "line/marker/14_5/微信图片_20240502093247.jpg",
                    "line/marker/14_5/谢裕大4A.png",
                    "line/marker/14_5/谢裕大茶博园4A.jpg"
                ],
                "longitude": 118.320583,
                "latitude": 29.867459,
                "id": 47,
                "icon": "line/14/6.png",
                "icon_scale": 90,
                "wh": 1.165,
                "icon_longitude": 118.249283,
                "icon_latitude": 29.884586
            },
            {
                "s_id": "14_6",
                "name": "岩寺新四军军部旧址纪念馆",
                "address": "徽州区岩寺镇滨河南路 39 号",
                "desc": "属于研学基地，可聆听讲解员讲述新四军故事，传承\"铁军精神\"",
                "thumbs": [
                    "line/marker/14_6/徽州区-岩寺新四军军部旧址纪念馆.jpg",
                    "line/marker/14_6/徽州区-岩寺新四军军部旧址纪念馆1.jpg"
                ],
                "longitude": 118.335971,
                "latitude": 29.820463,
                "id": 77,
                "icon": "line/14/7.png",
                "icon_scale": 90,
                "wh": 1.972,
                "icon_longitude": 118.380432,
                "icon_latitude": 29.820539
            },
            {
                "s_id": "14_7",
                "name": "大灵山旅游度假区",
                "address": "徽州区零四三村道",
                "desc": "可观赏爱情主题村落，观赏榆树",
                "thumbs": [
                    "line/marker/14_7/徽州区-大灵山度假区.jpg",
                    "line/marker/14_7/徽州区-大灵山度假区1.jpg",
                    "line/marker/14_7/徽州区-大灵山度假区2.jpg",
                    "line/marker/14_7/徽州区-大灵山度假区3.jpg"
                ],
                "longitude": 118.320372,
                "latitude": 29.916144,
                "id": 79,
                "icon": "line/14/8.png",
                "icon_scale": 90,
                "wh": 1.458,
                "icon_longitude": 118.281484,
                "icon_latitude": 30.003465
            },
            {
                "s_id": "14_8",
                "name": "呈坎",
                "address": "黄山市徽州区呈坎镇宝纶路78号",
                "desc": "可观赏徽派建筑与古桂树、永兴湖、宝纶阁",
                "thumbs": [
                    "line/marker/14_8/1.jpg",
                    "line/marker/14_8/2.jpg",
                    "line/marker/14_8/3.jpg",
                    "line/marker/14_8/4.jpg"
                ],
                "longitude": 118.280803,
                "latitude": 29.914335,
                "id": 131,
                "icon": "line/14/10.png",
                "icon_scale": 90,
                "wh": 1.393,
                "icon_longitude": 118.215769,
                "icon_latitude": 29.945976,
                "recommend": [
                    {
                        "name": "藕园餐厅",
                        "tel": "18955994288",
                        "address": "徽州区呈坎镇呈坎村后街68-4"
                    },
                    {
                        "name": "澍德堂",
                        "tel": "18955994588",
                        "address": "徽州区呈坎镇呈坎景区入口永兴湖畔"
                    }
                ]
            }
        ]
    },
    {
        "id": 15,
        "name": "湿地交响  生态观测体验之旅",
        "center": [
            30.4359,
            118.211787
        ],
        "zoom": 9.78,
        "points": [
            {
                "s_id": "15_1",
                "name": "红军北上抗日先遣队陈列馆",
                "address": "黄山区谭家桥镇中墩村，黄山区山深线与石门路交叉口西360米",
                "desc": "红军北上抗日先遣队陈列馆坐落于黄山市黄山区谭家桥镇，是为纪念中国红军北上抗日先遣队谭家桥战役而修建。馆内展出有大量珍贵的红军革命文物实物与图片，再现了红军北上抗日先遣队的战斗历程和峥嵘岁月。",
                "thumbs": [
                    "line/marker/15_1/军博园.jpg",
                    "line/marker/15_1/纪念馆1.jpg",
                    "line/marker/15_1/纪念馆2.jpg",
                    "line/marker/15_1/纪念馆3.jpg",
                    "line/marker/15_1/纪念馆4.jpg"
                ],
                "longitude": 118.249548,
                "latitude": 30.141228,
                "icon": "line/15/1.png",
                "icon_scale": 90,
                "wh": 1.928,
                "icon_longitude": 118.318136,
                "icon_latitude": 30.17589
            },
            {
                "s_id": "15_2",
                "name": "浦溪河休闲旅游区",
                "address": "浦溪河休闲旅游区",
                "desc": "地处城区近郊，交通便捷，湿地步道24小时免费开放。到浦溪河在晨雾或夕阳拍白鹭、夜鹭、野鸭等，赏120余亩湿地、观鸟塔、梦幻黄山文化体验馆等。",
                "thumbs": [
                    "line/marker/15_2/1.jpg",
                    "line/marker/15_2/2.jpg",
                    "line/marker/15_2/3.jpg"
                ],
                "longitude": 118.146142,
                "latitude": 30.258982,
                "icon": "line/15/2.png",
                "icon_scale": 90,
                "wh": 1.436,
                "icon_longitude": 118.114492,
                "icon_latitude": 30.275411
            },
            {
                "s_id": "15_3",
                "name": "翡翠谷景区",
                "address": "黄山区汤口镇山岔村翡翠谷景区",
                "desc": "可体验“亲子戏水”互动",
                "thumbs": [
                    "line/marker/15_3/黄山区-翡翠谷.jpg",
                    "line/marker/15_3/黄山区-翡翠谷1.jpg",
                    "line/marker/15_3/黄山区-翡翠谷2.jpg"
                ],
                "longitude": 118.219613,
                "latitude": 30.115275,
                "id": 73,
                "icon": "line/15/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.181394,
                "icon_latitude": 30.096309
            },
            {
                "s_id": "15_4",
                "name": "奇瑞途居黄山露营地",
                "address": "黄山市黄山区焦村镇",
                "desc": "可提供房车营位、帐篷营地、木屋等",
                "thumbs": [
                    "line/marker/15_4/途居星空.jpg",
                    "line/marker/15_4/途居黄山露营地1 (2).JPG",
                    "line/marker/15_4/途居黄山露营地1.jpg"
                ],
                "longitude": 118.098821,
                "latitude": 30.156204,
                "id": 43,
                "icon": "line/15/4.png",
                "icon_scale": 90,
                "wh": 1.502,
                "icon_longitude": 118.015005,
                "icon_latitude": 30.135266
            },
            {
                "s_id": "15_5",
                "name": "梦幻黄山文化体验馆",
                "address": "黄山市黄山区甘棠镇",
                "desc": "可观赏裸眼5D电影《飞越黄山》",
                "thumbs": [
                    "line/marker/15_5/IMG_4693(20240502-094158).JPG",
                    "line/marker/15_5/IMG_4694(20240502-102922).JPG",
                    "line/marker/15_5/IMG_4695.PNG",
                    "line/marker/15_5/IMG_4696(20240502-103108).JPG"
                ],
                "longitude": 118.132574,
                "latitude": 30.279578,
                "id": 41,
                "icon": "line/15/5.png",
                "icon_scale": 90,
                "wh": 1.922,
                "icon_longitude": 117.986371,
                "icon_latitude": 30.297949,
                "recommend": [
                    {
                        "name": "黄山饭店",
                        "tel": "0559-8510108",
                        "address": "黄山区平湖东路1号"
                    }
                ]
            },
            {
                "s_id": "15_6",
                "name": "南屏村",
                "address": "黟县碧阳镇南屏村",
                "desc": "可观赏香樟树、古巷迷宫",
                "thumbs": [
                    "line/marker/15_6/黟县-南屏.jpg",
                    "line/marker/15_6/黟县-南屏1.jpg",
                    "line/marker/15_6/黟县-南屏2.jpg",
                    "line/marker/15_6/黟县-南屏3.jpg"
                ],
                "longitude": 117.905067,
                "latitude": 29.898719,
                "id": 104,
                "icon": "line/15/6.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.866821,
                "icon_latitude": 29.913215
            },
            {
                "s_id": "15_7",
                "name": "秀里村",
                "address": "黄山市黟县宏村镇龙江村",
                "desc": "可体验旅拍，观赏域见未来草坪露营、云起艺术馆",
                "thumbs": [
                    "line/marker/15_7/HYPERLAPSE_0003-已增强-NR 拷贝.jpg",
                    "line/marker/15_7/图片15.jpg"
                ],
                "longitude": 117.952762,
                "latitude": 29.955424,
                "id": 141,
                "icon": "line/15/7.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.973582,
                "icon_latitude": 30.008116
            },
            {
                "s_id": "15_8",
                "name": "西递村",
                "address": "黄山市黟县西递镇西递村",
                "desc": "可观赏近景徽剧、水幕光影秀",
                "thumbs": [
                    "line/marker/15_8/微信图片_20220924210724汪洪.jpg",
                    "line/marker/15_8/微信图片_20221013113227汪洪 (5).jpg",
                    "line/marker/15_8/汪洪晒秋1.jpg"
                ],
                "longitude": 117.99599,
                "latitude": 29.90334,
                "id": 129,
                "icon": "line/15/8.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.042393,
                "icon_latitude": 29.92085
            },
            {
                "s_id": "15_9",
                "name": "利源村",
                "address": "黟县西递镇利源村",
                "desc": "黟县利源村位于黄山市黟县西递镇东部，距离西递镇仅3.5公里，地处传统村落保护区。该村以茶产业为主导，同时发展民宿、餐饮、研学等业态，并拥有特色咖啡馆“喝呀·日咖夜酒”。",
                "thumbs": [
                    "line/marker/15_9/利源村.jpg"
                ],
                "longitude": 118.014312,
                "latitude": 29.893625,
                "icon": "line/15/9.png",
                "icon_scale": 90,
                "wh": 1.642,
                "icon_longitude": 117.971902,
                "icon_latitude": 29.797857,
                "recommend": [
                    {
                        "name": "黟县西递黟乡大院食府",
                        "tel": "18155972777",
                        "address": "黟县031县道与032乡道交叉口东北300米"
                    },
                    {
                        "name": "黟县里厅山墅",
                        "tel": "13965121502",
                        "address": "黟县西递镇叶村利源组"
                    }
                ]
            }
        ]
    },
    {
        "id": 16,
        "name": "世界遗产·魅力自然 黄山度假探秘之旅",
        "center": [
            30.4359,
            118.211787
        ],
        "zoom": 9.2,
        "points": [
            {
                "s_id": "16_1",
                "name": "太平湖景区",
                "address": "黄山区太平湖镇",
                "desc": "可体验乘船游湖、水上运动",
                "thumbs": [
                    "line/marker/16_1/黄山区-太平湖.jpg",
                    "line/marker/16_1/黄山区-太平湖1.jpg"
                ],
                "longitude": 118.059916,
                "latitude": 30.400808,
                "id": 72,
                "icon": "line/16/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.096885,
                "icon_latitude": 30.23445
            },
            {
                "s_id": "16_2",
                "name": "浦溪河休闲旅游区",
                "address": "浦溪河休闲旅游区",
                "desc": "地处城区近郊，交通便捷，湿地步道24小时免费开放。到浦溪河在晨雾或夕阳拍白鹭、夜鹭、野鸭等，赏120余亩湿地、观鸟塔、梦幻黄山文化体验馆等。",
                "thumbs": [
                    "line/marker/16_2/1.jpg",
                    "line/marker/16_2/2.jpg",
                    "line/marker/16_2/3.jpg"
                ],
                "longitude": 118.146142,
                "latitude": 30.258982,
                "icon": "line/16/2.png",
                "icon_scale": 90,
                "wh": 2.156,
                "icon_longitude": 118.282057,
                "icon_latitude": 30.229353,
                "recommend": [
                    {
                        "name": "太平国际大酒店",
                        "tel": "0559-8513999",
                        "address": "黄山区平湖西路17号"
                    }
                ]
            },
            {
                "s_id": "16_3",
                "name": "黄山风景区",
                "address": "黄山区汤口镇 205 国道",
                "desc": "可观赏猴谷鸮类 、光明顶雀类；天都峰棕噪鹛、光明顶雀类；迎客松、梦笔生花、红嘴相思鸟，打卡西海小火车，南门下、梦笔生花、红嘴相思鸟，打卡西海小火车",
                "thumbs": [
                    "line/marker/16_3/黄山区-黄山风景区.jpg",
                    "line/marker/16_3/黄山区-黄山风景区1.jpg",
                    "line/marker/16_3/黄山区-黄山风景区2.jpg"
                ],
                "longitude": 118.170467,
                "latitude": 30.126561,
                "id": 71,
                "icon": "line/16/3.png",
                "icon_scale": 90,
                "wh": 1.838,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.166089,
                "icon_latitude": 30.070991,
                "recommend": [
                    {
                        "name": "徽菜十二道",
                        "tel": "0559-5577778",
                        "address": "黄山区汤口镇汤川路46号"
                    },
                    {
                        "name": "黄山风景区南门希尔顿花园酒店",
                        "tel": "0559-5576868 ",
                        "address": "黄山区汤川路46号"
                    }
                ]
            },
            {
                "s_id": "16_4",
                "name": "宏村",
                "address": "黟县宏村",
                "desc": "可观赏牛角红杨，《宏村阿菊》演出、南湖赏荷",
                "thumbs": [
                    "line/marker/16_4/黟县-宏村.jpg",
                    "line/marker/16_4/黟县-宏村1.jpg",
                    "line/marker/16_4/黟县-宏村2.jpg"
                ],
                "longitude": 117.990001,
                "latitude": 30.002422,
                "id": 100,
                "icon": "line/16/4.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.989956,
                "icon_latitude": 30.002582
            },
            {
                "s_id": "16_5",
                "name": "奇墅湖",
                "address": "黟县宏村镇奇墅村",
                "desc": "奇墅湖，又名“东方红水库”，是位于中国安徽省黟县宏村镇宏村西南方向3公里处的湖泊，距离县城10公里。该湖深水区域水深可达几十米，湖光山色交相辉映，景色宜人。",
                "thumbs": [
                    "line/marker/16_5/奇墅湖.jpg"
                ],
                "longitude": 117.98313,
                "latitude": 29.977482,
                "icon": "line/16/5.png",
                "icon_scale": 90,
                "wh": 1.701,
                "icon_longitude": 117.933428,
                "icon_latitude": 30.229844,
                "recommend": [
                    {
                        "name": "黟县奇墅仙境国际大酒店",
                        "tel": "0559-5548801",
                        "address": "黟县宏村镇奇墅村"
                    }
                ]
            },
            {
                "s_id": "16_6",
                "name": "祖源村",
                "address": "休宁县溪口镇祖源村",
                "desc": "祖源村偎依在海拔685米的插角尖山腰，生态绝佳，粉墙黛瓦，徽风古韵，风光迷人。村内拥有水口、古桥、思贤岭等人文景观，还有百亩梯田景观，尤以那棵千年红豆杉而闻名。这座始建于宋代的中国传统村落，先后入选国家森林乡村、全国乡村旅游重点村、中国美丽休闲乡村。",
                "thumbs": [
                    "line/marker/16_6/18 祖源村来龙山.jpg",
                    "line/marker/16_6/54 祖源村 (2).jpg",
                    "line/marker/16_6/54 祖源村.jpg"
                ],
                "longitude": 118.03611,
                "latitude": 29.660185,
                "icon": "line/16/6.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.839428,
                "icon_latitude": 29.622399
            },
            {
                "s_id": "16_7",
                "name": "横江湿地公园",
                "address": "休宁县樟树岛",
                "desc": "横江湿地公园，西起东亭河与横江交汇口，东达南潜大桥，北至东关碣，属河流型湿地公园，有樟树岛、鳌广场等水上活动区、体育健身区、文化体验区，该点位鸟类资源丰富，共有7目13科35种，其中国家一级保护动物有东方白鹳、白鹤，国家二级保护动物有灰鹤、海南鳽、黄嘴白鹭、鸳鸯和小天鹅。",
                "thumbs": [
                    "line/marker/16_7/3 横江公园 (3).jpg",
                    "line/marker/16_7/3 横江公园 (4).jpg",
                    "line/marker/16_7/3 横江公园 (5).JPG"
                ],
                "longitude": 118.265152,
                "latitude": 29.741381,
                "icon": "line/16/7.png",
                "icon_scale": 90,
                "wh": 1.414,
                "icon_longitude": 118.186683,
                "icon_latitude": 29.769337
            },
            {
                "s_id": "16_8",
                "name": "平里祁红小镇",
                "address": "祁门县平里镇平里村",
                "desc": "黄山市首批特色小镇，祁门红茶发源地，万里茶道申遗点。拥有茶文化遗址、祁红5G智能化生产车间、梅南公园、生态茶园等文旅资源，是茶文旅融合绝佳旅游目的地。",
                "thumbs": [
                    "line/marker/16_8/平里小镇.jpg"
                ],
                "longitude": 117.60918,
                "latitude": 29.7324198,
                "icon": "line/16/8.png",
                "icon_scale": 90,
                "wh": 1.084,
                "icon_longitude": 117.613741,
                "icon_latitude": 29.71132
            },
            {
                "s_id": "16_9",
                "name": "倒湖十八湾",
                "address": "祁门县芦溪乡芦溪村",
                "desc": "倒湖两山夹一湖，水面最宽处120米湖水平均深度达5米，绵延18公里，十八个湾口 湾湾景致迷人，又称倒湖十八湾，这里不仅有着水流湍急湖段，也有着碧静如丝的湖面，若至春和景明畅游，青山倒影湖面，两岸花红柳绿 波澜不惊，一碧万澈。岸边的茶园、油菜花海层层叠叠随处可见，野鸭、灰鹤，白鹭穿梭湖面，时起时落 如此景致让人窒息。",
                "thumbs": [
                    "line/marker/16_9/1.jpg"
                ],
                "longitude": 117.465533,
                "latitude": 29.692903,
                "icon": "line/16/9.png",
                "icon_scale": 90,
                "wh": 3.112,
                "icon_longitude": 117.772307,
                "icon_latitude": 29.827493,
                "recommend": [
                    {
                        "name": "章姐食堂",
                        "tel": "18714954880",
                        "address": "休宁县状元广场新华书店对面停车场入口处"
                    },
                    {
                        "name": "老电影院饺子店",
                        "tel": "0559-7535775",
                        "address": "休宁县萝宁街10号"
                    },
                    {
                        "name": "祖源梦乡村",
                        "tel": "18055928592",
                        "address": "休宁县祖源村村民委员会南侧160米"
                    },
                    {
                        "name": "开元一然·梅南渡",
                        "tel": "18755922239",
                        "address": "祁门县平里镇双程村"
                    },
                    {
                        "name": "青山白露",
                        "tel": "15705592957",
                        "address": "祁门县芦溪乡奇口村"
                    }
                ]
            }
        ]
    },
    {
        "id": 17,
        "name": "树灵秘境·鸟韵天堂 黄山生态休闲之旅",
        "center": [
            29.7759,
            118.4931787
        ],
        "zoom": 10.5,
        "points": [
            {
                "s_id": "17_1",
                "name": "花山谜窟",
                "address": "黄山市屯溪区花山路",
                "desc": "属于研学基地，可体验沉浸式探秘游",
                "thumbs": [
                    "line/marker/17_1/00bccf8f80f4c254fbe35ec7538dc2c.jpg",
                    "line/marker/17_1/654c1a3ae8c1c26a8d50c61a778d52f.jpg",
                    "line/marker/17_1/903ded8cc7c6d6af67974c1e7469fb5.jpg"
                ],
                "longitude": 118.389019,
                "latitude": 29.744423,
                "id": 35,
                "icon": "line/17/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.429728,
                "icon_latitude": 29.731919
            },
            {
                "s_id": "17_2",
                "name": "三江口时尚街区",
                "address": "黄山市屯溪区屯溪老街、屯溪河街、黎阳in巷",
                "desc": "属于潮玩三街",
                "thumbs": [
                    "line/marker/17_2/1.jpg",
                    "line/marker/17_2/DL508247-opq3210991471.jpg",
                    "line/marker/17_2/微信图片_20240921153327.jpg"
                ],
                "longitude": 118.310598,
                "latitude": 29.706947,
                "id": 145,
                "icon": "line/17/2.png",
                "icon_scale": 90,
                "wh": 1.318,
                "icon_longitude": 118.380418,
                "icon_latitude": 29.653767
            },
            {
                "s_id": "17_3",
                "name": "黄山演艺城",
                "address": "黄山市屯溪区黎阳镇西海路31号",
                "desc": "可观赏《徽秀》演艺",
                "thumbs": [
                    "line/marker/17_3/微信图片_20240922110347.jpg",
                    "line/marker/17_3/微信图片_20240922110351.jpg",
                    "line/marker/17_3/微信图片_20240922110355.jpg",
                    "line/marker/17_3/微信图片_20240922110502.jpg"
                ],
                "longitude": 118.288888,
                "latitude": 29.706528,
                "id": 148,
                "icon": "line/17/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.362579,
                "icon_latitude": 29.738655
            },
            {
                "s_id": "17_4",
                "name": "傍霞村观鸟基地",
                "address": "屯溪区黎阳镇鬲山大道19号",
                "desc": "这里树荫茂密，有鸟类 30 余种，重点观赏具有福寿寓意的寿带鸟。村里专门设置了保护屏障与告示牌，保护了400余亩茶园、林地，为鸟类提供了优良栖息空间。沿着铺设好的步行道沉浸式观鸟赏景，可使用观鸟屋、远程监控等设施，还能在观鸟景观台及观赏点全方位观察鸟类。",
                "thumbs": [
                    "line/marker/17_4/12傍霞村观鸟基地.png"
                ],
                "longitude": 118.258492,
                "latitude": 29.675683,
                "icon": "line/17/4.png",
                "icon_scale": 90,
                "wh": 1.913,
                "icon_longitude": 118.257062,
                "icon_latitude": 29.674886,
                "recommend": [
                    {
                        "name": "中国徽菜博物馆",
                        "tel": "0559-2333777",
                        "address": "屯溪区迎宾大道62号"
                    },
                    {
                        "name": "霞隐民宿",
                        "tel": "19155921616",
                        "address": "屯溪区黎阳镇傍霞村树仑10号"
                    }
                ]
            },
            {
                "s_id": "17_5",
                "name": "唐模",
                "address": "黄山市徽州区潜口镇唐模村潜唐路1号",
                "desc": "可观赏古银杏、水口园林，观赏槐荫树，研学基地，唐朝模范村，赏古银杏",
                "thumbs": [
                    "line/marker/17_5/唐模晒秋 (2).jpg",
                    "line/marker/17_5/唐模晒秋 (3).jpg",
                    "line/marker/17_5/唐模晒秋 (4).jpg",
                    "line/marker/17_5/唐模晒秋.jpg"
                ],
                "longitude": 118.336109,
                "latitude": 29.868462,
                "id": 132,
                "icon": "line/17/5.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.286,
                "icon_latitude": 29.837556
            },
            {
                "s_id": "17_6",
                "name": "西溪南",
                "address": "徽州区松明山公路",
                "desc": "可观赏普通鳾，秘境小火车，雾拍白鹇，寿带鸟，鸳鸯、罗汉松，赏“绿野仙踪”千亩枫杨林湿地、西西里秘境、丰溪竹筏、小火车等新业态",
                "thumbs": [
                    "line/marker/17_6/徽州区-西溪南.jpg",
                    "line/marker/17_6/徽州区-西溪南1.jpg",
                    "line/marker/17_6/徽州区-西溪南2.jpg"
                ],
                "longitude": 118.28485,
                "latitude": 29.84041,
                "id": 83,
                "icon": "line/17/6.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.361951,
                "icon_latitude": 29.815326
            },
            {
                "s_id": "17_7",
                "name": "呈坎",
                "address": "黄山市徽州区呈坎镇宝纶路78号",
                "desc": "可观赏徽派建筑与古桂树、永兴湖、宝纶阁",
                "thumbs": [
                    "line/marker/17_7/1.jpg",
                    "line/marker/17_7/2.jpg",
                    "line/marker/17_7/3.jpg",
                    "line/marker/17_7/4.jpg"
                ],
                "longitude": 118.280803,
                "latitude": 29.914335,
                "id": 131,
                "icon": "line/17/7.png",
                "icon_scale": 90,
                "wh": 1.474,
                "icon_longitude": 118.280803,
                "icon_latitude": 29.914335,
                "recommend": [
                    {
                        "name": "藕园餐厅",
                        "tel": "18955994288",
                        "address": "徽州区呈坎镇呈坎村后街68-4"
                    },
                    {
                        "name": "澍德堂",
                        "tel": "18955994588",
                        "address": "徽州区呈坎镇呈坎景区入口永兴湖畔"
                    }
                ]
            },
            {
                "s_id": "17_8",
                "name": "中国供销主题园",
                "address": "歙县郑村镇中国供销主题园",
                "desc": "中国供销主题园聚焦农文旅融合发力，加快供销“四季游”与康养研学、餐饮休闲、非遗文创等多业态融合，立足“科技+农业+旅游”发展战略，加快生态资源优势转化，以“花”为媒，以“花”引流，创意打造“春野、夏果、秋花、冬食”四季IP全时文旅矩阵。",
                "thumbs": [
                    "line/marker/17_8/黄山市中国供销主题园1.png",
                    "line/marker/17_8/黄山市中国供销主题园2.jpg"
                ],
                "longitude": 118.369479,
                "latitude": 29.863992,
                "icon": "line/17/8.png",
                "icon_scale": 90,
                "wh": 1.231,
                "icon_longitude": 118.519252,
                "icon_latitude": 29.809658
            },
            {
                "s_id": "17_9",
                "name": "徽州古城",
                "address": "黄山市歙县徽城镇徽州古城景区",
                "desc": "属于研学基地，徽州府衙，可探寻古徽州文化，可观赏沉浸式演出、安徽徽州历史博物馆",
                "thumbs": [
                    "line/marker/17_9/3fb1c60d613135fc36337e1f51cd133.jpg",
                    "line/marker/17_9/ae5d9f1fb9ae471e3b112ab056fc07a.jpg",
                    "line/marker/17_9/dee2d4c64eaea002b442899f0503ffe.jpg"
                ],
                "longitude": 118.436772,
                "latitude": 29.86602,
                "id": 146,
                "icon": "line/17/9.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.487407,
                "icon_latitude": 29.890355
            },
            {
                "s_id": "17_10",
                "name": "新安江山水画廊",
                "address": "黄山市歙县深渡镇新安江山水画廊景区",
                "desc": "可观赏九姓捕鱼表演、千年古樟树，九龙潭冰雪世界、绵潭戏院",
                "thumbs": [
                    "line/marker/17_10/DJI_1.jpg",
                    "line/marker/17_10/汪平徽-秋染新安江.jpg"
                ],
                "longitude": 118.618285,
                "latitude": 29.862743,
                "id": 143,
                "icon": "line/17/10.png",
                "icon_scale": 90,
                "wh": 2.62,
                "icon_longitude": 118.618285,
                "icon_latitude": 29.862743,
                "recommend": [
                    {
                        "name": "千百渡生态农庄",
                        "tel": "0559-2751616 ",
                        "address": "歙县深渡镇大茂村1号"
                    },
                    {
                        "name": "欣安居民宿",
                        "tel": "18755985188",
                        "address": "歙县深渡镇昌源路60号"
                    },
                    {
                        "name": "金丸岛·江深草阁",
                        "tel": "18155965088",
                        "address": "歙县绵潭村将军埠1号"
                    }
                ]
            }
        ]
    },
    {
        "id": 18,
        "name": "古树灵禽·黄山趣游漫行之旅",
        "center": [
            29.7759,
            118.2931787
        ],
        "zoom": 10.5,
        "points": [
            {
                "s_id": "18_1",
                "name": "西溪南",
                "address": "徽州区松明山公路",
                "desc": "可观赏普通鳾，秘境小火车，雾拍白鹇，寿带鸟，鸳鸯、罗汉松，赏“绿野仙踪”千亩枫杨林湿地、西西里秘境、丰溪竹筏、小火车等新业态",
                "thumbs": [
                    "line/marker/18_1/徽州区-西溪南.jpg",
                    "line/marker/18_1/徽州区-西溪南1.jpg",
                    "line/marker/18_1/徽州区-西溪南2.jpg"
                ],
                "longitude": 118.28485,
                "latitude": 29.84041,
                "id": 83,
                "icon": "line/18/1.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.388358,
                "icon_latitude": 29.800316
            },
            {
                "s_id": "18_2",
                "name": "谢裕大茶博园",
                "address": "黄山市徽州区潜口镇谢裕大东路99号",
                "desc": "属于研学基地，可体验以徽茶文化为核心的旅游，包括黄山毛峰品鉴、游乐项目等",
                "thumbs": [
                    "line/marker/18_2/微信图片_20240502093234.jpg",
                    "line/marker/18_2/微信图片_20240502093247.jpg",
                    "line/marker/18_2/谢裕大4A.png",
                    "line/marker/18_2/谢裕大茶博园4A.jpg"
                ],
                "longitude": 118.320583,
                "latitude": 29.867459,
                "id": 47,
                "icon": "line/18/2.png",
                "icon_scale": 90,
                "wh": 1.159,
                "icon_longitude": 118.357816,
                "icon_latitude": 29.881013
            },
            {
                "s_id": "18_3",
                "name": "大灵山旅游度假区",
                "address": "徽州区零四三村道",
                "desc": "可观赏爱情主题村落，观赏榆树",
                "thumbs": [
                    "line/marker/18_3/徽州区-大灵山度假区.jpg",
                    "line/marker/18_3/徽州区-大灵山度假区1.jpg",
                    "line/marker/18_3/徽州区-大灵山度假区2.jpg",
                    "line/marker/18_3/徽州区-大灵山度假区3.jpg"
                ],
                "longitude": 118.320372,
                "latitude": 29.916144,
                "id": 79,
                "icon": "line/18/3.png",
                "icon_scale": 90,
                "wh": 2.159,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.248525,
                "icon_latitude": 29.908858,
                "recommend": [
                    {
                        "name": "徽姑娘农家乐",
                        "tel": "18255922929",
                        "address": "徽州区043乡道下横街66号"
                    },
                    {
                        "name": "浪漫花涧民宿",
                        "tel": "18255922929",
                        "address": "徽州区043乡道下横街66号"
                    }
                ]
            },
            {
                "s_id": "18_4",
                "name": "新安江滨水旅游景区",
                "address": "黄山市屯溪区瑶里路8号",
                "desc": "可体验游船",
                "thumbs": [
                    "line/marker/18_4/新安江滨水旅游景区 (1).jpg",
                    "line/marker/18_4/新安江滨水旅游景区 (2).jpg",
                    "line/marker/18_4/新安江滨水旅游景区 (3).jpg"
                ],
                "longitude": 118.356439,
                "latitude": 29.729068,
                "id": 39,
                "icon": "line/18/4.png",
                "icon_scale": 90,
                "wh": 2.087,
                "icon_longitude": 118.408585,
                "icon_latitude": 29.718386,
                "recommend": [
                    {
                        "name": "徽三说（屯溪老街店）",
                        "tel": "0559-2775797",
                        "address": "黄山市屯溪区屯溪老街滨江西路4号"
                    },
                    {
                        "name": "黎阳观厅",
                        "tel": "15215590881",
                        "address": "黄山市屯溪区黎阳in巷街区内37幢"
                    }
                ]
            },
            {
                "s_id": "18_5",
                "name": "黄山演艺城",
                "address": "黄山市屯溪区黎阳镇西海路31号",
                "desc": "可观赏《徽秀》演艺",
                "thumbs": [
                    "line/marker/18_5/微信图片_20240922110347.jpg",
                    "line/marker/18_5/微信图片_20240922110351.jpg",
                    "line/marker/18_5/微信图片_20240922110355.jpg",
                    "line/marker/18_5/微信图片_20240922110502.jpg"
                ],
                "longitude": 118.288888,
                "latitude": 29.706528,
                "id": 148,
                "icon": "line/18/5.png",
                "icon_scale": 90,
                "wh": 1.009,
                "icon_longitude": 118.320007,
                "icon_latitude": 29.752444
            },
            {
                "s_id": "18_6",
                "name": "安徽中国徽州文化博物馆",
                "address": "安徽中国徽州文化博物馆",
                "desc": "安徽中国徽州文化博物馆位于黄山市屯溪迎宾大道50号，国家一级博物馆 ，馆藏近10万件文物，以徽墨、歙砚等为特色。馆内依《徽州人与徽州文化》设多个展厅，全面展现徽州历史与文化魅力。",
                "thumbs": [
                    "line/marker/18_6/徽州文化博物馆.jpg"
                ],
                "longitude": 118.274611,
                "latitude": 29.717693,
                "icon": "line/18/6.png",
                "icon_scale": 90,
                "wh": 1.785,
                "icon_longitude": 118.342667,
                "icon_latitude": 29.664155
            },
            {
                "s_id": "18_7",
                "name": "傍霞村观鸟基地",
                "address": "屯溪区黎阳镇鬲山大道19号",
                "desc": "这里树荫茂密，有鸟类 30 余种，重点观赏具有福寿寓意的寿带鸟。村里专门设置了保护屏障与告示牌，保护了400余亩茶园、林地，为鸟类提供了优良栖息空间。沿着铺设好的步行道沉浸式观鸟赏景，可使用观鸟屋、远程监控等设施，还能在观鸟景观台及观赏点全方位观察鸟类。",
                "thumbs": [
                    "line/marker/18_7/12傍霞村观鸟基地.png"
                ],
                "longitude": 118.258492,
                "latitude": 29.675683,
                "icon": "line/18/7.png",
                "icon_scale": 90,
                "wh": 1.075,
                "icon_longitude": 118.257265,
                "icon_latitude": 29.67227
            },
            {
                "s_id": "18_8",
                "name": "横江湿地公园",
                "address": "休宁县樟树岛",
                "desc": "横江湿地公园，西起东亭河与横江交汇口，东达南潜大桥，北至东关碣，属河流型湿地公园，有樟树岛、鳌广场等水上活动区、体育健身区、文化体验区，该点位鸟类资源丰富，共有7目13科35种，其中国家一级保护动物有东方白鹳、白鹤，国家二级保护动物有灰鹤、海南鳽、黄嘴白鹭、鸳鸯和小天鹅。",
                "thumbs": [
                    "line/marker/18_8/3 横江公园 (3).jpg",
                    "line/marker/18_8/3 横江公园 (4).jpg",
                    "line/marker/18_8/3 横江公园 (5).JPG"
                ],
                "longitude": 118.265152,
                "latitude": 29.741381,
                "icon": "line/18/8.png",
                "icon_scale": 90,
                "wh": 1.355,
                "icon_longitude": 118.186683,
                "icon_latitude": 29.769337
            },
            {
                "s_id": "18_9",
                "name": "向云端·世界观光列车微公园",
                "address": "黄山市休宁县齐云山镇张村",
                "desc": "可打卡“道境鸟视界”、网红小火车",
                "thumbs": [
                    "line/marker/18_9/1.png",
                    "line/marker/18_9/2.png",
                    "line/marker/18_9/微信图片_20240418150732.jpg"
                ],
                "longitude": 118.084877,
                "latitude": 29.811371,
                "id": 139,
                "icon": "line/18/9.png",
                "icon_scale": 90,
                "wh": 2.031,
                "icon_longitude": 118.080444,
                "icon_latitude": 29.740198
            },
            {
                "s_id": "18_10",
                "name": "齐云山生态文化旅游度假区",
                "address": "黄山市休宁县齐云山镇",
                "desc": "可观赏瑯梅古木，体验横江竹筏、白岳夜逍遥",
                "thumbs": [
                    "line/marker/18_10/齐云山 (2).jpg",
                    "line/marker/18_10/齐云山 (4).jpg"
                ],
                "longitude": 118.036434,
                "latitude": 29.809262,
                "id": 144,
                "icon": "line/18/10.png",
                "icon_scale": 90,
                "wh": 3.287,
                "icon_longitude": 118.04541,
                "icon_latitude": 29.819676,
                "recommend": [
                    {
                        "name": "齐镇酒家",
                        "tel": "13733051633",
                        "address": "休宁县齐云山镇岩前街5号"
                    },
                    {
                        "name": "祥瑞轩餐厅",
                        "tel": "0559-2661688",
                        "address": "齐云山风景区索道北侧齐云小镇入口处"
                    },
                    {
                        "name": "齐云山白岳/月华酒店",
                        "tel": "0559-2661688",
                        "address": "齐云山风景区索道北侧齐云小镇入口处"
                    }
                ]
            }
        ]
    },
    {
        "id": 19,
        "name": "古村寻幽・茶香鸟影 黄山秘境探趣之旅",
        "center": [
            29.8159,
            117.8731787
        ],
        "zoom": 10,
        "points": [
            {
                "s_id": "19_1",
                "name": "漫溪里生态旅游度假区",
                "address": "黄山市祁门县箬坑乡石舜村",
                "desc": "可体验亲子乐园、烟花篝火、星空露营",
                "thumbs": [
                    "line/marker/19_1/漫溪里小游乐园.jpg",
                    "line/marker/19_1/漫溪里小游乐园2.jpg",
                    "line/marker/19_1/漫溪里游船.png",
                    "line/marker/19_1/漫溪里露营.jpg"
                ],
                "longitude": 117.47215,
                "latitude": 29.976358,
                "id": 152,
                "icon": "line/19/1.png",
                "icon_scale": 90,
                "wh": 1.685,
                "icon_longitude": 117.629242,
                "icon_latitude": 29.91652
            },
            {
                "s_id": "19_2",
                "name": "历溪御医古村",
                "address": "祁门县历溪村",
                "desc": "为徽州五千村之一，因明代御医王琠而闻名于世。村中古桥、古祠、古树、古道、古民居写满了过往，参天错落的古树林更为华东古树群之首，它们与川流不息的舜溪河映带左右，置身其中疑为桃源异地。",
                "thumbs": [
                    "line/marker/19_2/历溪御医古村.jpg"
                ],
                "longitude": 117.498657,
                "latitude": 29.980025,
                "icon": "line/19/2.png",
                "icon_scale": 90,
                "wh": 1.087,
                "icon_longitude": 117.511758,
                "icon_latitude": 29.982804
            },
            {
                "s_id": "19_3",
                "name": "历溪大峡谷",
                "address": "祁门县历溪村",
                "desc": "可团体露营、亲子玩水、溯溪、浮潜等，徒步爱好者还能沿着山间小径，穿梭在茂密的竹林与古树间，听鸟鸣蝉噪，感受大自然的勃勃生机。",
                "thumbs": [
                    "line/marker/19_3/历溪大峡谷.jpg"
                ],
                "longitude": 117.498657,
                "latitude": 29.980025,
                "icon": "line/19/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 117.425163,
                "icon_latitude": 29.938836
            },
            {
                "s_id": "19_4",
                "name": "平里祁红小镇",
                "address": "祁门县平里镇平里村",
                "desc": "黄山市首批特色小镇，祁门红茶发源地，万里茶道申遗点。拥有茶文化遗址、祁红5G智能化生产车间、梅南公园、生态茶园等文旅资源，是茶文旅融合绝佳旅游目的地。",
                "thumbs": [
                    "line/marker/19_4/平里小镇.jpg"
                ],
                "longitude": 117.60918,
                "latitude": 29.7324198,
                "icon": "line/19/4.png",
                "icon_scale": 90,
                "wh": 2.616,
                "icon_longitude": 117.613741,
                "icon_latitude": 29.73132,
                "recommend": [
                    {
                        "name": "沐心·弈园",
                        "tel": "13399598480",
                        "address": "祁门县历口镇西塘村"
                    },
                    {
                        "name": "开元一然·梅南渡",
                        "tel": "18755922239",
                        "address": "祁门县平里镇双程村"
                    }
                ]
            },
            {
                "s_id": "19_5",
                "name": "祖源村",
                "address": "休宁县溪口镇祖源村",
                "desc": "祖源村偎依在海拔685米的插角尖山腰，生态绝佳，粉墙黛瓦，徽风古韵，风光迷人。村内拥有水口、古桥、思贤岭等人文景观，还有百亩梯田景观，尤以那棵千年红豆杉而闻名。这座始建于宋代的中国传统村落，先后入选国家森林乡村、全国乡村旅游重点村、中国美丽休闲乡村。",
                "thumbs": [
                    "line/marker/19_5/18 祖源村来龙山.jpg",
                    "line/marker/19_5/54 祖源村 (2).jpg",
                    "line/marker/19_5/54 祖源村.jpg"
                ],
                "longitude": 118.03611,
                "latitude": 29.660185,
                "icon": "line/19/5.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.839428,
                "icon_latitude": 29.622399
            },
            {
                "s_id": "19_6",
                "name": "齐云山生态文化旅游度假区",
                "address": "黄山市休宁县齐云山镇",
                "desc": "可观赏瑯梅古木，体验横江竹筏、白岳夜逍遥",
                "thumbs": [
                    "line/marker/19_6/齐云山 (2).jpg",
                    "line/marker/19_6/齐云山 (4).jpg"
                ],
                "longitude": 118.036434,
                "latitude": 29.809262,
                "id": 144,
                "icon": "line/19/6.png",
                "icon_scale": 90,
                "wh": 3.243,
                "icon_longitude": 118.094788,
                "icon_latitude": 29.743938,
                "recommend": [
                    {
                        "name": "齐镇酒家",
                        "tel": "13733051633",
                        "address": "休宁县齐云山镇岩前街5号"
                    },
                    {
                        "name": "祥瑞轩餐厅",
                        "tel": "0559-2661688",
                        "address": "齐云山风景区索道北侧齐云小镇入口处"
                    },
                    {
                        "name": "齐云山白岳/月华酒店",
                        "tel": "0559-2661688",
                        "address": "齐云山风景区索道北侧齐云小镇入口处"
                    }
                ]
            },
            {
                "s_id": "19_7",
                "name": "西递石林水世界",
                "address": "黄山市黟县西递镇叶村",
                "desc": "可体验水上项目",
                "thumbs": [
                    "line/marker/19_7/黟县-石林.jpg",
                    "line/marker/19_7/黟县-石林1.jpg",
                    "line/marker/19_7/黟县-石林2.jpg"
                ],
                "longitude": 118.047087,
                "latitude": 29.899879,
                "id": 108,
                "icon": "line/19/7.png",
                "icon_scale": 90,
                "wh": 1.302,
                "icon_longitude": 118.044766,
                "icon_latitude": 29.89866
            },
            {
                "s_id": "19_8",
                "name": "西递村",
                "address": "黄山市黟县西递镇西递村",
                "desc": "可观赏近景徽剧、水幕光影秀",
                "thumbs": [
                    "line/marker/19_8/微信图片_20220924210724汪洪.jpg",
                    "line/marker/19_8/微信图片_20221013113227汪洪 (5).jpg",
                    "line/marker/19_8/汪洪晒秋1.jpg"
                ],
                "longitude": 117.99599,
                "latitude": 29.90334,
                "id": 129,
                "icon": "line/19/8.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 117.968524,
                "icon_latitude": 29.964926
            },
            {
                "s_id": "19_9",
                "name": "南屏村",
                "address": "黟县碧阳镇南屏村",
                "desc": "可观赏香樟树、古巷迷宫",
                "thumbs": [
                    "line/marker/19_9/黟县-南屏.jpg",
                    "line/marker/19_9/黟县-南屏1.jpg",
                    "line/marker/19_9/黟县-南屏2.jpg",
                    "line/marker/19_9/黟县-南屏3.jpg"
                ],
                "longitude": 117.905067,
                "latitude": 29.898719,
                "id": 104,
                "icon": "line/19/9.png",
                "icon_scale": 90,
                "wh": 1.389,
                "icon_longitude": 117.905269,
                "icon_latitude": 29.899966,
                "recommend": [
                    {
                        "name": "晴园",
                        "tel": "13399590211",
                        "address": "黟县碧阳镇南屏村程家街1号"
                    }
                ]
            }
        ]
    },
    {
        "id": 20,
        "name": "山水画卷・徽韵传承 黄山揽胜寻踪之旅",
        "center": [
            29.98,
            118.536567
        ],
        "zoom": 9.7,
        "points": [
            {
                "s_id": "20_1",
                "name": "浦溪河休闲旅游区",
                "address": "浦溪河休闲旅游区",
                "desc": "地处城区近郊，交通便捷，湿地步道24小时免费开放。到浦溪河在晨雾或夕阳拍白鹭、夜鹭、野鸭等，赏120余亩湿地、观鸟塔、梦幻黄山文化体验馆等。",
                "thumbs": [
                    "line/marker/20_1/1.jpg",
                    "line/marker/20_1/2.jpg",
                    "line/marker/20_1/3.jpg"
                ],
                "longitude": 118.146142,
                "latitude": 30.258982,
                "icon": "line/20/1.png",
                "icon_scale": 90,
                "wh": 1.445,
                "icon_longitude": 118.128918,
                "icon_latitude": 30.230931
            },
            {
                "s_id": "20_2",
                "name": "芙蓉谷景区",
                "address": "黄山区耿诚镇辅村",
                "desc": "可观赏天空之境、体验山地飞车体验",
                "thumbs": [
                    "line/marker/20_2/黄山区-芙蓉谷.jpg",
                    "line/marker/20_2/黄山区-芙蓉谷1.jpg"
                ],
                "longitude": 118.158817,
                "latitude": 30.193576,
                "id": 74,
                "icon": "line/20/2.png",
                "icon_scale": 90,
                "wh": 1.67,
                "icon_longitude": 118.291855,
                "icon_latitude": 30.162741,
                "recommend": [
                    {
                        "name": "谭家大院",
                        "tel": "15805596622",
                        "address": "黄山区耿城镇饶村，梨园路与新三路交叉口东北方向100米"
                    }
                ]
            },
            {
                "s_id": "20_3",
                "name": "黄山风景区",
                "address": "黄山区汤口镇 205 国道",
                "desc": "可观赏猴谷鸮类 、光明顶雀类；天都峰棕噪鹛、光明顶雀类；迎客松、梦笔生花、红嘴相思鸟，打卡西海小火车，南门下、梦笔生花、红嘴相思鸟，打卡西海小火车",
                "thumbs": [
                    "line/marker/20_3/黄山区-黄山风景区.jpg",
                    "line/marker/20_3/黄山区-黄山风景区1.jpg",
                    "line/marker/20_3/黄山区-黄山风景区2.jpg"
                ],
                "longitude": 118.170467,
                "latitude": 30.126561,
                "id": 71,
                "icon": "line/20/3.png",
                "icon_scale": 90,
                "wh": 0.981,
                "lat": 30.267459,
                "lng": 120.145557,
                "icon_longitude": 118.164756,
                "icon_latitude": 30.069198
            },
            {
                "s_id": "20_4",
                "name": "呈坎",
                "address": "黄山市徽州区呈坎镇宝纶路78号",
                "desc": "可观赏徽派建筑与古桂树、永兴湖、宝纶阁",
                "thumbs": [
                    "line/marker/20_4/1.jpg",
                    "line/marker/20_4/2.jpg",
                    "line/marker/20_4/3.jpg",
                    "line/marker/20_4/4.jpg"
                ],
                "longitude": 118.280803,
                "latitude": 29.914335,
                "id": 131,
                "icon": "line/20/4.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.196411,
                "icon_latitude": 29.910707
            },
            {
                "s_id": "20_5",
                "name": "棠樾牌坊群",
                "address": "歙县郑村镇棠樾村",
                "desc": "可体验探寻七座牌坊的故事，观赏《棠樾之礼》等演出、徽派盆景",
                "thumbs": [
                    "line/marker/20_5/歙县-鲍家花园.jpg",
                    "line/marker/20_5/歙县-鲍家花园1.jpg",
                    "line/marker/20_5/歙县-鲍家花园2.jpg"
                ],
                "longitude": 118.369767,
                "latitude": 29.866902,
                "id": 88,
                "icon": "line/20/5.png",
                "icon_scale": 90,
                "wh": 1.576,
                "icon_longitude": 118.309967,
                "icon_latitude": 29.852612
            },
            {
                "s_id": "20_6",
                "name": "雄村",
                "address": "歙县雄村",
                "desc": "可体验竹筏、竹山书院",
                "thumbs": [
                    "line/marker/20_6/歙县-雄村.JPG",
                    "line/marker/20_6/歙县-雄村2.jpg"
                ],
                "longitude": 118.443313,
                "latitude": 29.815761,
                "id": 85,
                "icon": "line/20/6.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.441659,
                "icon_latitude": 29.814766
            },
            {
                "s_id": "20_7",
                "name": "徽州古城",
                "address": "黄山市歙县徽城镇徽州古城景区",
                "desc": "属于研学基地，徽州府衙，可探寻古徽州文化，可观赏沉浸式演出、安徽徽州历史博物馆",
                "thumbs": [
                    "line/marker/20_7/3fb1c60d613135fc36337e1f51cd133.jpg",
                    "line/marker/20_7/ae5d9f1fb9ae471e3b112ab056fc07a.jpg",
                    "line/marker/20_7/dee2d4c64eaea002b442899f0503ffe.jpg"
                ],
                "longitude": 118.436772,
                "latitude": 29.86602,
                "id": 146,
                "icon": "line/20/7.png",
                "icon_scale": 90,
                "wh": 2.174,
                "icon_longitude": 118.652376,
                "icon_latitude": 29.829679,
                "recommend": [
                    {
                        "name": "披云山庄（歙县）",
                        "tel": "0559-6530000",
                        "address": "歙县徽城镇披云路7号"
                    },
                    {
                        "name": "江祥泰民宿",
                        "tel": "18655998845",
                        "address": "歙县徽城镇斗山街35-37号"
                    },
                    {
                        "name": "九月徽州",
                        "tel": "0559-5278899",
                        "address": "歙县徽城镇打箍井街12号"
                    }
                ]
            },
            {
                "s_id": "20_8",
                "name": "瞻淇村",
                "address": "歙县北岸镇瞻淇村",
                "desc": "瞻淇村，村名“瞻淇”取自于《诗经·卫风》“瞻彼淇奥，绿竹猗猗”，至今已有1300多年历史。瞻淇鱼灯起源于宋代，至今已有800多年历史。宋代宋理宗时，瞻淇人丁兴旺，代代有官，以北京兵马总司汪翥，江苏县令汪鸿澡，江西九江府府台汪作霖为首，在村里兴起元宵节花灯，传承至今。每年正月初二至正月十八，村里都会举办盛大的嬉鱼灯会。",
                "thumbs": [
                    "line/marker/20_8/44 瞻淇村.jpg",
                    "line/marker/20_8/瞻淇村.jpg"
                ],
                "longitude": 118.520436,
                "latitude": 29.872633,
                "icon": "line/20/8.png",
                "icon_scale": 90,
                "wh": 0.981,
                "icon_longitude": 118.799177,
                "icon_latitude": 29.872984
            },
            {
                "s_id": "20_9",
                "name": "新安江山水画廊",
                "address": "黄山市歙县深渡镇新安江山水画廊景区",
                "desc": "可观赏九姓捕鱼表演、千年古樟树，九龙潭冰雪世界、绵潭戏院",
                "thumbs": [
                    "line/marker/20_9/DJI_1.jpg",
                    "line/marker/20_9/汪平徽-秋染新安江.jpg"
                ],
                "longitude": 118.618285,
                "latitude": 29.862743,
                "id": 143,
                "icon": "line/20/9.png",
                "icon_scale": 90,
                "wh": 1.212,
                "icon_longitude": 118.905693,
                "icon_latitude": 29.962292
            }
        ]
    }
]